<template>
    <div>
        <div v-if="product && Object.keys(product).length">
            <section class="breadcrumb-section">
                <div class="container">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>

                            <li
                                v-if="is_tshirt_24_hour"
                                class="breadcrumb-item"
                            >
                                <router-link
                                    :to="{
                                        name: 'product_list_24_tshirt',
                                        params: { product_type: 'tshirt24' }
                                    }"
                                    >24hour T-shirt</router-link
                                >
                            </li>

                            <li
                                v-else-if="product.Category"
                                class="breadcrumb-item"
                            >
                                <router-link
                                    :to="{
                                        path:
                                            '/product-list/' +
                                            productTypePath +
                                            '/' +
                                            product.Category.id
                                    }"
                                    >{{ product.Category.title }}</router-link
                                >
                            </li>

                            <li
                                class="breadcrumb-item active"
                                aria-current="page"
                            >
                                Product Details
                            </li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section
                class="product_details pt_20 product_details_vue product_details_update product_details_update_v3"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-lg-6 pr-lg-0 pro-mobile-0">
                            <div class="gallery-container">
                                <ProductZoomer
                                    :product="product"
                                    v-if="!isEmpty(images)"
                                    :base-images="images"
                                    :base-zoomer-options="zoomerOptions"
                                />
                            </div>
                            <div
                                class="share mx-auto d-flex justify-content-center align-items-center mt_30"
                            >
                                <h6 class="font_size_18 m-0">SHARE:</h6>
                                <div
                                    class="sharethis-inline-share-buttons"
                                ></div>
                                <ul class="share_item ml_16 my-0">
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnFacebook"
                                            ><img
                                                src="/maincss/images/share_fb.svg"
                                                alt="Facebook"
                                        /></a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnTwitter"
                                            ><img
                                                src="/maincss/images/twitterx.svg"
                                                width="22px"
                                                height="22px"
                                                alt="Twitter"
                                        /></a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnInstagram"
                                            ><img
                                                src="/maincss/images/share_instagram.svg"
                                                alt="Instagram"
                                        /></a>
                                    </li>
                                </ul>
                            </div>
                            <div class="product_detail_tabs pt-0 pb-40-bottom">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul
                                                class="nav nav-tabs default_tabs"
                                                id="product_tabs"
                                                role="tablist"
                                            >
                                                <li
                                                    v-if="product.description"
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link active"
                                                        id="home-tab1"
                                                        data-toggle="tab"
                                                        href="#product_details"
                                                        role="tab"
                                                        aria-controls="home"
                                                        aria-selected="true"
                                                        >Product Details</a
                                                    >
                                                </li>
                                                <li
                                                    v-if="
                                                        more_decoration_list.length >
                                                        0
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="profile-tab1"
                                                        data-toggle="tab"
                                                        href="#decoration"
                                                        role="tab"
                                                        aria-controls="profile"
                                                        aria-selected="false"
                                                        >Decoration</a
                                                    >
                                                </li>
                                                <li
                                                    v-if="
                                                        product.Brand &&
                                                        product.Brand
                                                            .size_chart_image
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="contact-tab1"
                                                        data-toggle="tab"
                                                        href="#size_chart"
                                                        role="tab"
                                                        aria-controls="contact"
                                                        aria-selected="false"
                                                        >Size Chart</a
                                                    >
                                                </li>
                                            </ul>
                                            <div
                                                class="tab-content"
                                                id="myTabContent"
                                            >
                                                <div
                                                    class="tab-pane fade show active"
                                                    v-if="product.description"
                                                    id="product_details"
                                                    role="tabpanel"
                                                    aria-labelledby="home-tab1"
                                                >
                                                    <h4
                                                        class="font_size_20 mb-0"
                                                    >
                                                        Product Description
                                                    </h4>
                                                    <h5
                                                        class="font_size_20 mb-0 mt_28"
                                                        v-html="
                                                            product.description
                                                        "
                                                    ></h5>
                                                    <br />
                                                    <a
                                                        v-if="
                                                            product.product_specification_sheet_url
                                                        "
                                                        :href="
                                                            product.product_specification_sheet_url
                                                        "
                                                        target="_blank"
                                                        >Product Spec Sheet</a
                                                    >
                                                </div>

                                                <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        more_decoration_list.length >
                                                        0
                                                    "
                                                    id="decoration"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab1"
                                                >
                                                    <div class="tabs_table">
                                                        <div
                                                            class="available_color_columns no_borders_custom decoration_table_product_detais_custom"
                                                        >
                                                            <table
                                                                class="table table-bordered"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Name
                                                                        </th>
                                                                        <th
                                                                            width="700"
                                                                        >
                                                                            Description
                                                                        </th>
                                                                        <th>
                                                                            Decoration
                                                                            Type
                                                                        </th>
                                                                        <th>
                                                                            Price
                                                                        </th>
                                                                        <th>
                                                                            Add
                                                                            On
                                                                            Price
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr
                                                                        v-for="(
                                                                            moredecoration,
                                                                            index
                                                                        ) in more_decoration_list"
                                                                        :key="
                                                                            index
                                                                        "
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                moredecoration.name
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moredecoration.description
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moredecoration.decoration_type
                                                                            }}
                                                                        </td>
                                                                        <td
                                                                            class="edit-table-column"
                                                                            @mouseover="
                                                                                isHovering = true
                                                                            "
                                                                            @mouseout="
                                                                                isHovering = false
                                                                            "
                                                                        >
                                                                            <template
                                                                                v-if="
                                                                                    moredecoration.price_type ==
                                                                                    'Price'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        moredecoration.price
                                                                                    )
                                                                                }}
                                                                            </template>
                                                                            <template
                                                                                v-else
                                                                            >
                                                                                <span
                                                                                    v-html="
                                                                                        tireName(
                                                                                            moredecoration.tier_id
                                                                                        )
                                                                                    "
                                                                                >
                                                                                </span>
                                                                            </template>
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                icPriceFormat(
                                                                                    moredecoration.add_on_price
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        product.Brand &&
                                                        product.Brand
                                                            .size_chart_image
                                                    "
                                                    id="size_chart"
                                                    role="tabpanel"
                                                    aria-labelledby="contact-tab1"
                                                >
                                                    <div
                                                        class="product_details product_details_vue"
                                                    >
                                                        <div
                                                            class="products_count_tab mt_30 product_details_content"
                                                        >
                                                            <div
                                                                class="products_count_tab"
                                                            >
                                                                <embed
                                                                    v-if="
                                                                        getUrlExtension(
                                                                            product
                                                                                .Brand
                                                                                .size_chart_image
                                                                        ) ==
                                                                        'pdf'
                                                                    "
                                                                    :src="`${product.Brand.size_chart_image}#toolbar=0&navpanes=0&scrollbar=0`"
                                                                    width="100%"
                                                                    height="800px"
                                                                />
                                                                <img
                                                                    v-else
                                                                    :src="
                                                                        product
                                                                            .Brand
                                                                            .size_chart_image
                                                                    "
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-md-12 col-lg-6 pl_84 pr_34 product_details_content"
                        >
                            <div class="product_headding d-flex">
                                <h1 class="heading1 w-75">
                                    {{ product.name | capitalize }}
                                </h1>
                                <div
                                    v-if="product.Brand"
                                    class="company_logo ml-auto w-25 text-right"
                                >
                                    <router-link
                                        v-tooltip="product.Brand.name"
                                        :to="{
                                            path:
                                                '/brand/' +
                                                (product.Brand.slug
                                                    ? product.Brand.slug
                                                    : product.Brand.id)
                                        }"
                                    >
                                        <img
                                            :src="
                                                product.Brand.logo_file
                                                    ? product.Brand.logo_file
                                                    : '/maincss/images/brand_logo.png'
                                            "
                                            alt=" "
                                        />
                                    </router-link>
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt_6">
                                <h4
                                    class="font_size_28 text_primary_blue m-0 text-uppercase"
                                >
                                    {{ product.product_number }}
                                </h4>
                            </div>

                            <div class="product_details_content">
                                <div class="product_details_radio_btn">
                                    <form action="#">
                                        <div
                                            class="form__group d-flex align-items-center mt_28"
                                        >
                                            <div
                                                v-show="
                                                    decoration_services_show
                                                "
                                                v-for="(
                                                    dec_service, dec_key
                                                ) in decoration_services"
                                                :class="
                                                    (dec_service.isActive
                                                        ? 'active '
                                                        : '') +
                                                    'form__radio-group'
                                                "
                                                :key="
                                                    dec_service.decoration_type
                                                "
                                            >
                                                <input
                                                    type="radio"
                                                    name="decoration_services"
                                                    :id="dec_service.id"
                                                    :value="dec_service.name"
                                                    :checked="
                                                        dec_service.isActive
                                                    "
                                                    v-on:input="
                                                        changeDecorationService(
                                                            dec_key
                                                        )
                                                    "
                                                    class="form__radio-input"
                                                />
                                                <label
                                                    :for="dec_service.id"
                                                    class="form__label-radio"
                                                >
                                                    <img
                                                        src="/maincss/images/checked_shipping_white.svg"
                                                        alt=""
                                                    />
                                                    {{ dec_service.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div
                                    class="d-flex product_count_pricing mt_24 flex-wrap product_x-scroll"
                                    v-if="decoration_type"
                                >
                                    <div
                                        class="product_count"
                                        v-for="(
                                            decorationvalues, index
                                        ) in decoration_price_template_values"
                                        :key="index"
                                    >
                                        <div
                                            class="count_item_heading"
                                            v-if="
                                                decoration_type == 1 ||
                                                decoration_type == 3
                                            "
                                        >
                                            <h6 class="m-0">
                                                {{ decorationvalues.quantity }}
                                            </h6>
                                        </div>
                                        <div
                                            class="count_item_heading"
                                            v-if="decoration_type == 2"
                                        >
                                            <h6 class="m-0">
                                                {{ decorationvalues.quantity1 }}
                                            </h6>
                                        </div>
                                        <div class="count_item_price">
                                            <h6
                                                class="m-0"
                                                v-if="decoration_type == 1"
                                            >
                                                {{
                                                    icPriceFormat(
                                                        getRetailPrice({
                                                            base_price:
                                                                parseFloat(
                                                                    product.price_base
                                                                ),
                                                            markup_price:
                                                                parseFloat(
                                                                    product.price_markup_value
                                                                ),
                                                            single_location_price:
                                                                parseFloat(
                                                                    decorationvalues.colour1
                                                                ),
                                                            color_category_price:
                                                                getDarkLightFees(
                                                                    default_selected_color
                                                                )
                                                        })
                                                    )
                                                }}
                                            </h6>
                                            <h6
                                                class="m-0"
                                                v-if="decoration_type == 2"
                                            >
                                                {{
                                                    icPriceFormat(
                                                        getRetailPrice({
                                                            base_price:
                                                                parseFloat(
                                                                    product.price_base
                                                                ),
                                                            markup_price:
                                                                parseFloat(
                                                                    product.price_markup_value
                                                                ),
                                                            single_location_price:
                                                                parseFloat(
                                                                    decorationvalues.cost
                                                                ),
                                                            color_category_price:
                                                                getDarkLightFees(
                                                                    default_selected_color
                                                                ),
                                                            decoration_discount_percentage:
                                                                parseFloat(
                                                                    decorationvalues.discount
                                                                )
                                                        })
                                                    )
                                                }}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p
                                class="base_price mt-1"
                                v-if="product.decoration_type == 1"
                            >
                                *Base price includes 1-color imprint in
                                1-location up to size XL. Larger sizes may incur
                                additional costs. Customize further to see
                                additional pricing.
                            </p>
                            <p
                                class="base_price mt-1"
                                v-if="product.decoration_type == 2"
                            >
                                *Pricing includes embroidery up to 8,000
                                stitches in 1-location up to size XL. Larger
                                sizes may incur additional costs. +$0.50 per
                                additional 1,000 stitches over 8,000.
                            </p>

                            <div class="products_count_tab mt_30">
                                <ul
                                    class="nav nav-tabs overfolw_x_scroll"
                                    id="myTab"
                                    role="tablist"
                                >
                                    <li
                                        @click="activeLink(index)"
                                        class="nav-item"
                                        :class="{ active: is_active == index }"
                                        v-for="(gender, index) in gender_groups"
                                        :key="index"
                                        role="presentation"
                                    >
                                        <a
                                            class="nav-link"
                                            :id="index + '-tab'"
                                            role="tab"
                                            aria-controls="profile"
                                            aria-selected="false"
                                            >{{ gender.gender }}</a
                                        >
                                    </li>
                                </ul>
                                <div
                                    class="row"
                                    v-for="(gender, index) in gender_groups"
                                    :key="index"
                                    v-show="index == is_active"
                                >
                                    <div
                                        class="col-md-10 col-lg-9 color_checkboxes_mr"
                                    >
                                        <h4
                                            class="available_colors font_size_17 mt_20 mb_0"
                                        >
                                            Available Colors
                                        </h4>
                                        <div
                                            class="d-flex flex-wrap justify-content-left color_checkbox"
                                        >
                                            <div
                                                v-for="(
                                                    gendercolors, ind
                                                ) in colors"
                                                :key="ind"
                                                class="form-check pl-0 mt_10"
                                            >
                                                <label
                                                    v-show="ind <= 9"
                                                    class="checkbox_custom"
                                                    v-tooltip="
                                                        gendercolors.color_name
                                                    "
                                                    :class="{
                                                        'checkmark-black':
                                                            gendercolors.is_selected &&
                                                            gendercolors.hash ==
                                                                '#ffffff',
                                                        'check-active':
                                                            gendercolors.is_selected &&
                                                            gendercolors.hash !=
                                                                '#ffffff'
                                                    }"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :id="`gender_${gender.id}_color_${gendercolors.id}`"
                                                        :name="
                                                            'avilable_color_' +
                                                            index
                                                        "
                                                        @change="
                                                            getsizeByColor(
                                                                gendercolors,
                                                                $event
                                                            )
                                                        "
                                                        v-model="
                                                            gendercolors.is_selected
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            gendercolors.swatches
                                                        "
                                                        :src="
                                                            gendercolors.swatches
                                                        "
                                                        class="checkmark"
                                                        :class="[
                                                            gendercolors.hash ==
                                                            '#FFFFFF'
                                                                ? 'bg-white'
                                                                : ''
                                                        ]"
                                                    />
                                                    <span
                                                        v-else
                                                        :class="
                                                            gendercolors.hash.trim() ==
                                                            '#ffffff'
                                                                ? 'checkmark checkmark_black'
                                                                : 'checkmark'
                                                        "
                                                        v-bind:style="
                                                            'background:' +
                                                            gendercolors.hash
                                                        "
                                                    ></span>
                                                </label>

                                                <div v-if="is_color_show_more">
                                                    <label
                                                        v-show="ind > 9"
                                                        class="checkbox_custom"
                                                        v-tooltip="
                                                            gendercolors.color_name
                                                        "
                                                        :class="{
                                                            'checkmark-black':
                                                                gendercolors.is_selected &&
                                                                gendercolors.hash ==
                                                                    '#ffffff',
                                                            'check-active':
                                                                gendercolors.is_selected &&
                                                                gendercolors.hash !=
                                                                    '#ffffff'
                                                        }"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            :id="`gender_${gender.id}_color_${gendercolors.id}`"
                                                            :name="
                                                                'avilable_color_' +
                                                                index
                                                            "
                                                            @change="
                                                                getsizeByColor(
                                                                    gendercolors,
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                gendercolors.is_selected
                                                            "
                                                        />
                                                        <img
                                                            v-if="
                                                                gendercolors.swatches
                                                            "
                                                            :src="
                                                                gendercolors.swatches
                                                            "
                                                            class="checkmark"
                                                            :class="[
                                                                gendercolors.hash ==
                                                                '#FFFFFF'
                                                                    ? 'bg-white'
                                                                    : ''
                                                            ]"
                                                        />
                                                        <span
                                                            v-else
                                                            :class="
                                                                gendercolors.hash.trim() ==
                                                                '#ffffff'
                                                                    ? 'checkmark checkmark_black'
                                                                    : 'checkmark'
                                                            "
                                                            v-bind:style="
                                                                'background:' +
                                                                gendercolors.hash
                                                            "
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div
                                                v-show="colors.length > 10"
                                                class="form-check pl-0 mt_10"
                                            >
                                                <label class="checkbox_custom">
                                                    <input
                                                        type="checkbox"
                                                        @click="
                                                            showMore(
                                                                'is_color_show_more'
                                                            )
                                                        "
                                                    />
                                                    <span
                                                        class="checkmark check_box plus_icon-align"
                                                        v-bind:class="
                                                            is_color_show_more
                                                                ? 'minus_box'
                                                                : ''
                                                        "
                                                    >
                                                        <img
                                                            v-if="
                                                                is_color_show_more
                                                            "
                                                            src="/maincss/images/minus1.svg"
                                                        />
                                                        <template v-else
                                                            >+{{
                                                                colors.length -
                                                                10
                                                            }}</template
                                                        >
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-content mt_12"
                                    id="myTabContent"
                                >
                                    <div
                                        class="tab-pane fade show active"
                                        v-for="(gender, index) in gender_groups"
                                        :key="index"
                                        :id="index"
                                        role="tabpanel"
                                        :aria-labelledb="index + '-tab'"
                                        v-show="is_active == index"
                                    >
                                        <div class="tab_pro_panel">
                                            <div
                                                v-for="picked_color in gender.selected_colors"
                                                :key="picked_color.id"
                                                class="tabs_table d-md-flex size_color_table"
                                            >
                                                <div
                                                    class="available_color_columns"
                                                >
                                                    <div
                                                        class="color d-flex align-items-center color_column"
                                                    >
                                                        <img
                                                            v-if="
                                                                picked_color.swatches
                                                            "
                                                            class="color_box mr_10"
                                                            :src="
                                                                picked_color.swatches
                                                            "
                                                        />
                                                        <div
                                                            v-else
                                                            class="color_box mr_10"
                                                            :style="
                                                                'background: ' +
                                                                picked_color.hash
                                                            "
                                                        ></div>
                                                        <h5 class="color-name">
                                                            {{
                                                                converToCamel(
                                                                    picked_color.color_name
                                                                )
                                                            }}
                                                            - Sizes
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div class="sizez_columns">
                                                    <div
                                                        class="d-flex flex-wrap inner_size_table"
                                                    >
                                                        <div
                                                            class="product_count"
                                                            v-for="(
                                                                gendersizes,
                                                                indx
                                                            ) in picked_color[
                                                                'unique_sizes'
                                                            ]"
                                                            :key="indx"
                                                        >
                                                            <div
                                                                class="count_item_heading"
                                                            >
                                                                <h6 class="m-0">
                                                                    {{
                                                                        gendersizes
                                                                            .Size
                                                                            .size
                                                                    }}
                                                                </h6>
                                                                <span>
                                                                    {{
                                                                        icPriceFormat(
                                                                            getRetailPrice(
                                                                                {
                                                                                    base_price:
                                                                                        parseFloat(
                                                                                            gendersizes.price_base
                                                                                        ),
                                                                                    markup_price:
                                                                                        parseFloat(
                                                                                            gendersizes.markup_price
                                                                                        ),
                                                                                    single_location_price:
                                                                                        parseFloat(
                                                                                            gendersizes.single_location_price ||
                                                                                                0
                                                                                        ),
                                                                                    color_category_price:
                                                                                        getDarkLightFees(
                                                                                            picked_color
                                                                                        ),
                                                                                    decoration_discount_percentage:
                                                                                        gendersizes.decoration_discount_percentage
                                                                                }
                                                                            )
                                                                        )
                                                                    }}
                                                                </span>
                                                            </div>
                                                            <div
                                                                class="count_item_price"
                                                            >
                                                                <input
                                                                    type="text"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                                                    v-model="
                                                                        gendersizes.quantity
                                                                    "
                                                                    @change="
                                                                        calculatePricing(
                                                                            index,
                                                                            gendersizes,
                                                                            $event
                                                                        )
                                                                    "
                                                                    class="form-control"
                                                                    placeholder="0"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="product_count total_count"
                                                        >
                                                            <div
                                                                class="count_item_heading"
                                                            >
                                                                <h6 class="m-0">
                                                                    Total
                                                                </h6>
                                                            </div>
                                                            <div
                                                                class="count_item_price total_box"
                                                            >
                                                                <b>{{
                                                                    icPriceFormat(
                                                                        picked_color.total_cost_gender_wise
                                                                    )
                                                                }}</b>
                                                                <!-- <input readonly type="text" :value="icPriceFormat(picked_color.total_cost_gender_wise)"
                                  class="form-control" placeholder="0" /> -->
                                                                <div
                                                                    class="dropdown"
                                                                    v-if="
                                                                        picked_color.total_qty_gender_wise >
                                                                        0
                                                                    "
                                                                >
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="dropdown-toggle d-flex align-items-center"
                                                                        :id="
                                                                            'dropdownMenuButton' +
                                                                            picked_color.id
                                                                        "
                                                                        data-toggle="dropdown"
                                                                        aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/path.png"
                                                                            class="ml_6 path"
                                                                        />
                                                                    </a>

                                                                    <div
                                                                        class="dropdown-menu drop-cart-menu drop_product"
                                                                        aria-labelledby="dropdownMenuButton"
                                                                    >
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20"
                                                                        >
                                                                            {{
                                                                                converToCamel(
                                                                                    picked_color.color_name
                                                                                )
                                                                            }}
                                                                            <span
                                                                                class="cross_ic"
                                                                            >
                                                                                <img
                                                                                    src="/maincss/images/cross.svg"
                                                                                />
                                                                            </span>
                                                                        </h4>
                                                                        <div
                                                                            class="scroll"
                                                                        >
                                                                            <div>
                                                                                <div
                                                                                    class="col-md-12"
                                                                                >
                                                                                    <div
                                                                                        class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                                    >
                                                                                        <div
                                                                                            class="table-responsive"
                                                                                        >
                                                                                            <table
                                                                                                width="100%"
                                                                                                class="table-bordered comma-decimal-place table-data table-hover space_b"
                                                                                            >
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th>
                                                                                                            Size
                                                                                                        </th>
                                                                                                        <th>
                                                                                                            Quantity
                                                                                                        </th>
                                                                                                        <th>
                                                                                                            Total
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    <tr
                                                                                                        v-for="(
                                                                                                            size,
                                                                                                            ind
                                                                                                        ) in picked_color[
                                                                                                            'unique_sizes'
                                                                                                        ]"
                                                                                                        :key="
                                                                                                            ind
                                                                                                        "
                                                                                                        v-show="
                                                                                                            size.quantity >
                                                                                                            0
                                                                                                        "
                                                                                                    >
                                                                                                        <td
                                                                                                            class="size"
                                                                                                        >
                                                                                                            {{
                                                                                                                size
                                                                                                                    .Size
                                                                                                                    .size
                                                                                                            }}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {{
                                                                                                                size.quantity
                                                                                                            }}
                                                                                                            *
                                                                                                            {{
                                                                                                                icPriceFormat(
                                                                                                                    size.cost
                                                                                                                )
                                                                                                            }}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {{
                                                                                                                icPriceFormat(
                                                                                                                    size.total_cost
                                                                                                                )
                                                                                                            }}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-12"
                                                                                >
                                                                                    <div
                                                                                        class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                                        v-if="
                                                                                            parseFloat(
                                                                                                picked_color.total_design_fee
                                                                                            ) >
                                                                                            0
                                                                                        "
                                                                                    >
                                                                                        <p
                                                                                            class="font-weight-bold w-90 m-0"
                                                                                        >
                                                                                            Design
                                                                                            Fee:
                                                                                        </p>
                                                                                        <p
                                                                                            class="ml-auto mb-0"
                                                                                        >
                                                                                            {{
                                                                                                picked_color.total_design_fee >=
                                                                                                0
                                                                                                    ? icPriceFormat(
                                                                                                          picked_color.total_design_fee
                                                                                                      )
                                                                                                    : 0.0
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span
                                                        class="d-block multiple_error"
                                                        v-if="
                                                            picked_color.existing_cart_quantity
                                                        "
                                                    >
                                                        This color already added
                                                        in cart with
                                                        {{
                                                            picked_color.existing_cart_quantity
                                                        }}.
                                                    </span>
                                                </div>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="mt-1"
                                                >
                                                    <img
                                                        @click="
                                                            getsizeByColor(
                                                                picked_color
                                                            )
                                                        "
                                                        src="/maincss/images/icons/delete_dark.svg"
                                                    />
                                                </a>
                                            </div>
                                        </div>

                                        <!-- START IMPRINT LOCATION COLORS -->
                                        <div
                                            class="right_section_main"
                                            v-if="choose_imprint_locations"
                                        >
                                            <h5
                                                class="mt-4"
                                                v-if="
                                                    product.decoration_type == 1
                                                "
                                            >
                                                Select imprint locations and
                                                number of ink colors
                                            </h5>
                                            <h5
                                                class="mt-4"
                                                v-else-if="
                                                    product.decoration_type == 2
                                                "
                                            >
                                                Select embroidery locations and
                                                number of thread colors
                                            </h5>
                                            <div class="right_section">
                                                <div class="alignment_section">
                                                    <div
                                                        class="right_items w-100"
                                                        :class="{
                                                            checkbox_checked:
                                                                implicitylocation.is_selected
                                                        }"
                                                        v-for="(
                                                            implicitylocation,
                                                            l_inx
                                                        ) in imprint_locations"
                                                        :key="l_inx"
                                                    >
                                                        <div
                                                            class="images_right"
                                                            @click="
                                                                selectImprintLocations(
                                                                    l_inx
                                                                )
                                                            "
                                                        >
                                                            <img
                                                                class="direct"
                                                                :src="
                                                                    implicitylocation.image_path
                                                                "
                                                                alt=""
                                                            />
                                                            <input
                                                                type="checkbox"
                                                                :name="
                                                                    'is_selected_location' +
                                                                    l_inx
                                                                "
                                                                :class="{
                                                                    checked:
                                                                        implicitylocation.is_selected
                                                                }"
                                                                :id="
                                                                    'same-address' +
                                                                    l_inx
                                                                "
                                                                :checked="
                                                                    implicitylocation.is_selected
                                                                "
                                                            />
                                                        </div>
                                                        <p>
                                                            {{
                                                                implicitylocation.location
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="select-imprint-area mt_24 popup_right_section"
                                                    v-show="is_imprint_location"
                                                >
                                                    <div
                                                        class="imprint-area-box imprint-product_area_box mb_40 popup_dropdown"
                                                    >
                                                        <div id="accordion">
                                                            <div class="">
                                                                <div
                                                                    class=""
                                                                    id="select-one"
                                                                >
                                                                    <h5
                                                                        class="mb-0"
                                                                        v-for="(
                                                                            implicitylocation,
                                                                            l_inx
                                                                        ) in imprint_locations"
                                                                        :key="
                                                                            l_inx
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="left-chest-"
                                                                            v-if="
                                                                                implicitylocation.is_selected
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="row left_botom_0"
                                                                            >
                                                                                <div
                                                                                    class="col-md-6 align-self-end drop-sec"
                                                                                >
                                                                                    <label
                                                                                        class="label-head"
                                                                                        style="
                                                                                            cursor: pointer;
                                                                                        "
                                                                                        for="left-chest"
                                                                                    >
                                                                                        {{
                                                                                            implicitylocation.location
                                                                                        }}
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                1
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            ink
                                                                                            colors)
                                                                                        </p>
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                2
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            thread
                                                                                            colors)
                                                                                        </p>
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                3
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            vinyl
                                                                                            colors)
                                                                                        </p>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-4"
                                                                                >
                                                                                    <div
                                                                                        class="form-group mt-0"
                                                                                    >
                                                                                        <v-select
                                                                                            width="100%"
                                                                                            placeholder="Select-colors"
                                                                                            label="value"
                                                                                            :reduce="
                                                                                                (
                                                                                                    color
                                                                                                ) =>
                                                                                                    color.id
                                                                                            "
                                                                                            :options="
                                                                                                imprintcityColors
                                                                                            "
                                                                                            v-model="
                                                                                                implicitylocation.no_of_color
                                                                                            "
                                                                                            @input="
                                                                                                selectNumberOfColors(
                                                                                                    implicitylocation,
                                                                                                    $event
                                                                                                )
                                                                                            "
                                                                                        ></v-select>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-2 cost_right"
                                                                                >
                                                                                    <span
                                                                                        class="mt-1"
                                                                                        v-if="
                                                                                            implicitylocation.decoration_fee
                                                                                        "
                                                                                    >
                                                                                        +
                                                                                        {{
                                                                                            icPriceFormat(
                                                                                                implicitylocation.decoration_fee
                                                                                            )
                                                                                        }}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <!-- <div :id="`collapseColors${l_inx}`"
                                                                                class="collapse show"
                                                                                aria-labelledby="select-one"
                                                                                data-parent="#accordion">
                                                                                <div class="card-body">
                                                                                    <div class="row select_color"
                                                                                        v-show="implicitylocation.no_of_color > 0"
                                                                                        v-for="(colors, c_inx) in implicitylocation.colors"
                                                                                        :key="c_inx">
                                                                                        <div
                                                                                            class="col-md-6 align-self-end drop_menus">
                                                                                            <label>
                                                                                                <span
                                                                                                    v-if="decoration_type == 1">
                                                                                                    Select
                                                                                                    Imprint
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                                <span
                                                                                                    v-else-if="decoration_type == 2">
                                                                                                    Select
                                                                                                    Thread
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                                <span
                                                                                                    v-else-if="decoration_type == 3">
                                                                                                    Select
                                                                                                    Vinyl
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div class="col-md-6">
                                                                                            <div class="form-group mt_0">
                                                                                                <v-select
                                                                                                    :filter="fuseSearch"
                                                                                                    :options="filterVendorColors(imprint_colors_array_for_template, l_inx)"
                                                                                                    :get-option-label="(option) => option.color_name"
                                                                                                    placeholder="Select"
                                                                                                    v-model="colors.color"
                                                                                                    @input="getColorWiseCost(c_inx, l_inx, is_active, $event)">
                                                                                                    <template
                                                                                                        #option="{ color_value, color_name, swatch_file }">
                                                                                                        <span
                                                                                                            v-if="color_value">
                                                                                                            <cite
                                                                                                                class="imprint_color_box"
                                                                                                                v-bind:style="'background:' + color_value"></cite>
                                                                                                            {{
                                                                                                                color_name
                                                                                                            }}
                                                                                                        </span>
                                                                                                        <span v-else>
                                                                                                            <img class="imprint_color_box"
                                                                                                                :src="swatch_file"
                                                                                                                alt="" />
                                                                                                            {{
                                                                                                                color_name
                                                                                                            }}
                                                                                                        </span>
                                                                                                    </template>
                                                                                                </v-select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div> -->
                                                                        </div>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- END IMPRINT LOCATION COLORS -->

                                        <!-- <div class="d-md-flex mt_26 cost_total_col" v-if="hashcolor[index]"> -->
                                        <div
                                            class="d-md-flex mt_26 cost_total_col"
                                        >
                                            <div
                                                class="quantity d-flex align-items-center"
                                            >
                                                <h4 class="font_size_22 mb-0">
                                                    Quantity
                                                </h4>
                                                <h3
                                                    class="font_size_35 mb-0 ml_10"
                                                >
                                                    {{
                                                        gender.total_qty_gender_wise
                                                    }}
                                                </h3>
                                                <h4
                                                    class="font_size_22 mb-0 ml_10"
                                                    v-if="
                                                        current_cart_quantity >
                                                        0
                                                    "
                                                >
                                                    Cart Qty
                                                </h4>
                                                <h3
                                                    class="font_size_35 mb-0 ml_10"
                                                    v-if="
                                                        current_cart_quantity >
                                                        0
                                                    "
                                                >
                                                    {{ current_cart_quantity }}
                                                </h3>
                                            </div>
                                            <div
                                                class="quantity d-flex align-items-center ml_16"
                                            >
                                                <h4
                                                    class="font_size_22 mb-0 cost_heading"
                                                >
                                                    Total Cost
                                                </h4>

                                                <h3
                                                    class="font_size_35 mb-0 ml_10"
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            gender.total_cost_gender_wise
                                                        )
                                                    }}
                                                </h3>

                                                <div
                                                    class="dropdown"
                                                    v-if="
                                                        showBreakupCharges(
                                                            gender
                                                        )
                                                    "
                                                >
                                                    <a
                                                        href="javascript:void(0);"
                                                        class="dropdown-toggle d-flex align-items-center"
                                                        :id="'dropdownCostButton'"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        <img
                                                            src="/maincss/images/path.png"
                                                            class="ml_6 path"
                                                        />
                                                    </a>

                                                    <div
                                                        class="dropdown-menu drop-cart-menu drop_product"
                                                        aria-labelledby="dropdownCostButton"
                                                    >
                                                        <h4
                                                            class="font_size_16 text_primary_blue py_2 px_20"
                                                        >
                                                            Cost
                                                            <span
                                                                class="cross_ic"
                                                            >
                                                                <img
                                                                    src="/maincss/images/cross.svg"
                                                                />
                                                            </span>
                                                        </h4>
                                                        <div class="scroll">
                                                            <div
                                                                class="dropdown-item d-flex align-items-center"
                                                            >
                                                                <p
                                                                    class="font-weight-bold w-25"
                                                                >
                                                                    Sub Total:
                                                                </p>
                                                                <p
                                                                    class="ml-auto"
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            gender.subtotal
                                                                        )
                                                                    }}
                                                                </p>
                                                            </div>
                                                            <div
                                                                class="dropdown-item d-flex align-items-center"
                                                                v-if="
                                                                    gender.total_color_fee
                                                                "
                                                            >
                                                                <p
                                                                    class="font-weight-bold w-25"
                                                                >
                                                                    Decoration
                                                                    Colors Fee:
                                                                </p>
                                                                <p
                                                                    class="ml-auto"
                                                                >
                                                                    {{
                                                                        gender.total_color_fee
                                                                            ? icPriceFormat(
                                                                                  gender.total_color_fee
                                                                              )
                                                                            : icPriceFormat(
                                                                                  0.0
                                                                              )
                                                                    }}
                                                                </p>
                                                            </div>
                                                            <div
                                                                class="dropdown-item d-flex align-items-center"
                                                                v-if="
                                                                    setup_fee_applied_gender_index >=
                                                                    0
                                                                "
                                                            >
                                                                <p
                                                                    class="font-weight-bold w-25"
                                                                    v-if="
                                                                        product.decoration_type ==
                                                                        1
                                                                    "
                                                                >
                                                                    Per Color
                                                                    Setup Fee (
                                                                    {{
                                                                        total_decoration_colors_count
                                                                    }}
                                                                    *
                                                                    {{
                                                                        icPriceFormat(
                                                                            per_color_setup_cost
                                                                        )
                                                                    }}
                                                                    ):
                                                                </p>
                                                                <p
                                                                    class="font-weight-bold w-25"
                                                                    v-else-if="
                                                                        product.decoration_type ==
                                                                        2
                                                                    "
                                                                >
                                                                    Digitizing
                                                                    Fee:
                                                                </p>
                                                                <p
                                                                    class="ml-auto"
                                                                >
                                                                    {{
                                                                        setup_fee_applied_gender_index >=
                                                                        0
                                                                            ? icPriceFormat(
                                                                                  setup_fee
                                                                              )
                                                                            : 0.0
                                                                    }}
                                                                </p>
                                                            </div>
                                                            <div
                                                                class="dropdown-item d-flex align-items-center"
                                                                v-if="
                                                                    gender.total_design_fee
                                                                "
                                                            >
                                                                <p
                                                                    class="font-weight-bold w-25"
                                                                >
                                                                    Design Fee:
                                                                </p>
                                                                <p
                                                                    class="ml-auto"
                                                                >
                                                                    {{
                                                                        gender.total_design_fee
                                                                            ? icPriceFormat(
                                                                                  gender.total_design_fee
                                                                              )
                                                                            : 0.0
                                                                    }}
                                                                </p>
                                                            </div>

                                                            <!-- <div class="dropdown-item d-flex align-items-center"
                                                                v-if="gender.total_decoration_discount_value">
                                                                <p class="font-weight-bold w-25">Line Item Discount:</p>
                                                                <p class="ml-auto">- {{ icPriceFormat(gender.total_decoration_discount_value) }}</p>
                                                            </div> -->
                                                            <div
                                                                class="dropdown-item d-flex align-items-center"
                                                                v-if="
                                                                    gender.total_discount_value
                                                                "
                                                            >
                                                                <p
                                                                    class="font-weight-bold w-25"
                                                                >
                                                                    Discount:
                                                                </p>
                                                                <p
                                                                    class="ml-auto"
                                                                >
                                                                    -
                                                                    {{
                                                                        gender.total_discount_value
                                                                            ? icPriceFormat(
                                                                                  gender.total_discount_value
                                                                              )
                                                                            : icPriceFormat(
                                                                                  0.0
                                                                              )
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <p
                                    class="base_price"
                                    v-if="product.decoration_type == 1"
                                >
                                    *Base price includes 1-color imprint in
                                    1-location up to size XL. Larger sizes may
                                    incur additional costs. Customize further to
                                    see additional pricing.
                                </p>
                                <p
                                    class="base_price"
                                    v-if="product.decoration_type == 2"
                                >
                                    *Pricing includes embroidery up to 8,000
                                    stitches in 1-location up to size XL. Larger
                                    sizes may incur additional costs. +$0.50 per
                                    additional 1,000 stitches over 8,000.
                                </p>

                                <div class="action-contents">
                                    <a href="javascript:void(0);">
                                        <img
                                            src="/maincss/images/path.png"
                                            alt=""
                                    /></a>
                                    <p class="m-0">
                                        Want to add another shirt style with the
                                        same artwork? Click “Start Designing“
                                        button. If not, click the Add Artwork
                                        Work button to add or create your
                                        artwork.
                                    </p>
                                </div>
                                <div class="buttons mt_0 add_new_button">
                                    <a
                                        href="Javascript:void(0);"
                                        class="btn btn_orange btn btn_orange bg_primary_orange text_white login-cart"
                                        :class="{ disabled: disable_btns }"
                                        @click="openStartDesignModal"
                                    >
                                        Start Designing/Add Artwork
                                    </a>

                                    <div
                                        class="modal login-form-popup like_design_popup fade h-auto"
                                        id="add-art-work"
                                        tabindex="-1"
                                        aria-labelledby="art-work"
                                        aria-hidden="true"
                                        data-keyboard="false"
                                        data-backdrop="static"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered"
                                        >
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <div class="header_items">
                                                        <div>
                                                            <h5
                                                                class="modal-title"
                                                            >
                                                                How would you
                                                                like to design
                                                                your item ?
                                                            </h5>
                                                        </div>

                                                        <div
                                                            class="close_modal"
                                                        >
                                                            <a
                                                                href="#"
                                                                class="popup-close art_poup_close"
                                                                id="popup-close"
                                                                data-dismiss="modal"
                                                                ref="popupclose"
                                                            >
                                                                <span
                                                                    aria-hidden="true"
                                                                    v-tooltip="
                                                                        'Close'
                                                                    "
                                                                    >&times;</span
                                                                >
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-body">
                                                    <div
                                                        class="form-check"
                                                        @click="
                                                            start_designing_with =
                                                                'scratch'
                                                        "
                                                    >
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault1"
                                                            @click="
                                                                start_designing_with =
                                                                    'scratch'
                                                            "
                                                            checked
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            @click="
                                                                start_designing_with =
                                                                    'scratch'
                                                            "
                                                            for="flexRadioDefault1"
                                                        >
                                                            Start from scratch
                                                            with Imprint City
                                                            Text and Graphics
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault2"
                                                            @click="
                                                                start_designing_with =
                                                                    'existing'
                                                            "
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="flexRadioDefault2"
                                                            @click="
                                                                start_designing_with =
                                                                    'existing'
                                                            "
                                                        >
                                                            Use One of My
                                                            Existing Design
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault3"
                                                            @click="
                                                                start_designing_with =
                                                                    'upload'
                                                            "
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="flexRadioDefault3"
                                                            @click="
                                                                start_designing_with =
                                                                    'upload'
                                                            "
                                                        >
                                                            Upload some new
                                                            graphics
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button
                                                        type="button"
                                                        @click="startDesign()"
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--crop popup-->
                <div
                    class="modal login-form-popup fade h-auto"
                    id="crop_modal"
                    tabindex="-1"
                    aria-labelledby="login"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable large_popup_l upload_art_popup"
                    >
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>Upload</h3>
                                <a
                                    href="#"
                                    class="popup-close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                    @click="cancelUploadArtwork"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        alt=" "
                                    />
                                </a>
                            </div>
                            <div class="modal-body">
                                <div class="login-form">
                                    <div class="upload_crop_design_studio row">
                                        <div class="left_panel col-md-6">
                                            <input
                                                class="crop_bdr"
                                                id="crop_bdr"
                                                type="file"
                                                @change="croppie"
                                                v-tooltip="
                                                    'Accepting png, jpg, and jpeg format'
                                                "
                                            />
                                            <span class="uplod-size"
                                                >Accepting only Png, Jpg, Jpeg,
                                                Svg, Pdf, Ai, Eps files</span
                                            >
                                            <small
                                                class="form-text text-error"
                                                v-if="
                                                    crop_image_validation == 1
                                                "
                                                >Incorrect image format.Please
                                                upload the Png, Jpg, Jpeg, Svg,
                                                Pdf, Ai, Eps file formats</small
                                            >
                                            <small
                                                class="form-text text-error"
                                                v-if="
                                                    image_size_validation == 1
                                                "
                                                >Please upload images greater
                                                than 1000px X 1000px</small
                                            >
                                        </div>

                                        <div
                                            class="form-check brand_logo_img col-md-6"
                                        >
                                            <label
                                                v-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'pdf'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/pdf.svg"
                                                        alt="pdf"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'ai'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/ai_format_image.png"
                                                        alt="postscript"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'eps'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/eps_formate_image.png"
                                                        alt="postscript"
                                                        width="100"
                                                        height="100"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <img
                                                    :src="
                                                        croppieImage
                                                            ? croppieImage
                                                            : '/maincss/design-studio/img/design-st-upload.jpg'
                                                    "
                                                    class
                                                    alt="Size Chart Logo"
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <small
                                        class="form-text text-error text-left"
                                        v-show="errors.has('uploadform.image')"
                                    >
                                        {{ errors.first("uploadform.image") }}
                                    </small>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    style="
                                        background-color: #f2790c !important;
                                        color: #fff !important;
                                        border: 1px solid #f2790c !important;
                                    "
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                    id="crop_btn"
                                    type="button"
                                    @click="crop"
                                >
                                    <img
                                        src="/maincss/images/upload-white.svg"
                                        alt=" "
                                    />
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- START DESIGNING POPUP -->
                <div
                    class="modal fade h-auto login-form-popup"
                    id="design-confirmation-modal"
                    tabindex="-1"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered upload-artwork"
                    >
                        <div class="modal-content">
                            <div class="modal-body">
                                <a
                                    href="#"
                                    class="popup-close art_poup_close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        v-tooltip="'Close'"
                                        alt=" "
                                    />
                                </a>
                                <div class="login-form">
                                    <h3>Start Designing</h3>
                                    <p class="upload_design_p">
                                        Your selected Artwork will be removed if
                                        you will design this product, Are you
                                        sure?
                                    </p>
                                    <div class="upload_design">
                                        <div
                                            class="d-flex justify-content-center mb_20 start_design_btn_box"
                                        >
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white mx_6"
                                                type="button"
                                                @click="startDesign()"
                                            >
                                                Continue
                                            </button>
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn_outline_primary border_primary_blue text_primary_blue mx_6"
                                                data-dismiss="modal"
                                                >Cancel</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PREVIEW MODEL -->
                <div
                    v-if="
                        getUrlExtension(preview_artwork_images) != 'ai' &&
                        getUrlExtension(preview_artwork_images) != 'eps'
                    "
                    class="modal fade cart_preview"
                    id="preview_modals"
                    data-backdrop="static"
                    data-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-xl large_popup"
                    >
                        <div class="modal-content">
                            <div class="modal-header border-bottom-0 p-0">
                                <button
                                    @click="cancelPreviewImages"
                                    type="button"
                                    class="close py-2 pr-3"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <img src="/maincss/images/cancel.svg" />
                                </button>
                            </div>
                            <!-- <img v-else alt="" :id="`default-artwork-${index}`" src="/maincss/images/mug_2.png" /> -->
                            <div class="modal-body pt-0">
                                <div
                                    v-if="
                                        getUrlExtension(
                                            preview_artwork_images
                                        ) == 'pdf'
                                    "
                                    class="mx-auto preview-image mb_20"
                                >
                                    <!-- <img  :src="preview_artwork_images" alt="pdf"> -->
                                    <iframe
                                        :src="preview_artwork_images"
                                        width="500px"
                                        height="300px"
                                    ></iframe>
                                </div>
                                <div v-else class="mx-auto preview-image mb_20">
                                    <img :src="preview_artwork_images" alt="" />
                                </div>
                                <div class="mx-auto preview-image">
                                    <!-- <button class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.final_proof_image : '', 'FinalProofImage', index)">Download</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div
            v-else-if="!isBusy"
            class="accessdenie border-0"
            style="background-color: #fff"
        >
            <div class="subhead page_404_box">
                <p class="mb_20">This product is no longer available</p>
                <router-link
                    class="btn btn_primary bg_primary_blue text_white"
                    :to="{ name: 'home' }"
                    >Back to home page</router-link
                >
            </div>
        </div>

        <section
            class="smilar_product pb-0 pt-0 smilar_product_align product_similar"
            v-if="companion_products.length > 0"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="heading2">Similar products</h2>
                    </div>
                </div>
                <div class="row mt_30">
                    <div
                        class="col-md-4 col-lg-2"
                        v-for="(similarproducts, index) in companion_products"
                        :key="index"
                    >
                        <div class="product">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center"
                            >
                                <router-link
                                    :to="{
                                        name: 'product_details',
                                        params: {
                                            id_of_product: similarproducts.id
                                        }
                                    }"
                                >
                                    <img
                                        v-if="!is_tshirt_24_hour"
                                        :src="
                                            similarproducts.product_default_image
                                        "
                                    />
                                    <img
                                        v-else
                                        :src="
                                            similarproducts.t_shirt_24_hour_image
                                        "
                                    />
                                </router-link>
                            </div>
                            <div class="product_content p-sm-0">
                                <h5 class="font_size_18">
                                    {{ similarproducts.product_number }}
                                </h5>
                                <p>
                                    {{
                                        similarproducts.Brand
                                            ? similarproducts.Brand.name
                                            : ""
                                    }}
                                </p>
                                <p>{{ similarproducts.name }}</p>
                                <p>
                                    <DisplayProductPrice
                                        :product="similarproducts"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import Fuse from "fuse.js";
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
import { SITE_URL } from "@/common/config";
import {
    FETCH_DECORATION_PRICES,
    FETCH_DECORATION_TEMPLATE
} from "@/store/actions.type";
export default {
    name: "ProductDetails",
    metaInfo() {
        return {
            title: this.product ? this.product.name : "",
            titleTemplate: "%s | Imprintcity",
            meta: [
                {
                    vmid: "title",
                    name: "title",
                    content: this.product
                        ? `${this.product.name} | Imprintcity`
                        : ""
                },
                {
                    vmid: "description",
                    name: "description",
                    content:
                        this.product && this.product.description
                            ? this.product.description.replace(/<[^>]+>/g, "")
                            : ""
                },
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: this.product ? this.product.keywords : ""
                }
            ]
        };
    },
    components: {
        DisplayProductPrice
    },

    data() {
        return {
            croppieImage: "",
            image_width: "",
            images_name: "",
            image_height: "",
            preview_artwork_images: "",
            crop_image_validation: 0,
            image_size_validation: 0,
            temp_product_artwork: "",
            product_artwork: "",
            image_uploaded: null,
            uploadedImages: [],
            isHovering: false,
            isBusy: false,
            size_list: [],
            gender_age_list: [],
            imprint_colors_array_for_template: [],
            books: [
                {
                    author: "author 11",
                    title: "title 11"
                },
                {
                    author: "author 22",
                    title: "title 22"
                }
            ],
            default_imprint_colors: [
                {
                    id: 1,
                    value: "1-colors"
                },
                {
                    id: 2,
                    value: "2-colors"
                },
                {
                    id: 3,
                    value: "3-colors"
                },
                {
                    id: 4,
                    value: "4-colors"
                },
                {
                    id: 5,
                    value: "5-colors"
                },
                {
                    id: 6,
                    value: "6-colors"
                }
            ],
            imprintcityColors: [],
            imprint_locations: [],
            is_favorite_product: false,
            favorite_product: [],
            is_imprint_location: false,
            is_color_show_more: false,
            product: {},
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            decoration_price_template_location2: [],
            product_color: [],
            is_active: false,
            is_active_bottom: false,
            qty: [],
            total_uantity: 0,
            total_cost: 0,
            companion_products: [],
            more_decoration_list: [],
            tier_list: [],
            hashcolor: [],
            color_size_qty: [],
            decoration_type: "",
            retail_price_without_price_template: 0,
            main_retail_price: 0,
            individual_cost: 0,
            option_value: false,
            productTypeName: "",
            productTypePath: "apparel",
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                gender_age_ids: [],
                searchKeyword: ""
            },
            temp_img: {},
            images: {
                thumbs: [
                    {
                        id: 1,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    },
                    {
                        id: 2,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    }
                ],
                normal_size: [
                    {
                        id: 1,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    },
                    {
                        id: 2,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    }
                ]
            },
            zoomerOptions: {
                zoomFactor: 3, // scale for zoomer
                pane: "pane", // three type of pane ['pane', 'container-round', 'container']
                hoverDelay: 300, // how long after the zoomer take effect
                namespace: "zoomer", // add a namespace for zoomer component, useful when on page have mutiple zoomer
                move_by_click: false, // move image by click thumb image or by mouseover
                scroll_items: 500, // thumbs for scroll
                choosed_thumb_border_color: "#bbdefb", // choosed thumb border color
                scroller_button_style: "line",
                scroller_position: "left",
                zoomer_pane_position: "right"
            },
            //gender groups
            gender_groups: [],
            groupedSizesByColors: [], //sizes grouped by color
            colors: [], //colors list from sub products
            sizesby_selected_color: [], //sizes list according to selected color
            selected_color: "",
            setup_fee: false,
            setup_fee_applied_gender_index: -1,
            design_fee: 0,
            cart_items: [],
            current_cart_quantity: 0,
            choose_imprint_locations: false,
            max_cart_count: 2000,
            error_message: "",
            all_quantity: 0,
            disable_btns: true,
            temp_decoration_services: null,
            decoration_services: [],
            decoration_services_show: false,
            decoration_methods: [],
            print_templates_id: null,
            embroidery_template_ids: null,
            promotional_template_ids: null,
            decoration_method_template_ids: [],
            xl_has_quantity: false,
            site_url: "",
            current_product_type: null,
            same_artwork_cart_items: [],
            default_selected_color: null,
            start_designing_with: "scratch",
            minimum_quantity_decoration_fee: 0,
            print_areas: [],
            markup_tiers: [],
            is_tshirt_24_hour: false,
            total_decoration_colors_count: 0,
            per_color_setup_cost: 0
        };
    },

    created() {
        const maxDimensionsRule = {
            getMessage(field, [width, height], data) {
                return (
                    (data && data.message) ||
                    `The ${field} field must be up to ${width} pixels by ${height} pixels.`
                );
            },
            validate(files, [width, height]) {
                const validateImage = (file, width, height) => {
                    const URL = window.URL || window.webkitURL;
                    return new Promise((resolve) => {
                        const image = new Image();
                        image.onerror = () => resolve({ valid: false });
                        image.onload = () =>
                            resolve({
                                valid:
                                    image.width <= Number(width) &&
                                    image.height <= Number(height) // only change from official rule
                            });

                        image.src = URL.createObjectURL(file);
                    });
                };
                const list = [];
                for (let i = 0; i < files.length; i++) {
                    // if file is not an image, reject.
                    if (!/\.(jpg|jpeg|png)$/i.test(files[i].name)) {
                        return false;
                    }
                    list.push(files[i]);
                }
                return Promise.all(
                    list.map((file) => validateImage(file, width, height))
                );
            }
        };

        this.$validator.extend("maxdimensions", maxDimensionsRule);
    },

    beforeMount() {
        this.is_tshirt_24_hour = this.$route.name == "24hoursTShirts";
    },

    mounted() {
        /* eslint-disable */
        $("#crop_btn").prop("disabled", true);
        $(".cr-slider").prop("disabled", true);
        document.body.classList.remove("bg_primary_light_white");
        var _this = this;

        _this.getSingleProductData();
        _this.getTiers();
        _this.activeLink(0);

        if (this.isAuthenticatedClient) {
            // setTimeout(function () { _this.UploadedImages() }, 2000);
            _this.getCartItems();
        }
        $(document).on("hide.bs.modal", "#add-art-work", function () {
            _this.$validator.reset();
            _this.image_uploaded = null;
            if (_this.$refs.fileInput) {
                _this.$refs.fileInput.value = null;
            }
            //Do stuff here
        });
        /* eslint-enable */
        this.site_url = SITE_URL;
    },

    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "decorationPrices",
            "decorationTemplate",
            "printTemplates",
            "embroideryTemplates"
        ])
    },
    methods: {
        getPrintArea(product_type_id) {
            let _this = this;
            _this.isBusy = true;
            return new Promise((resolve, reject) => {
                ApiService.get("/product-types/" + product_type_id)
                    .then(({ data }) => {
                        if (data.product_type.canvas_design_areas) {
                            _this.print_areas = JSON.parse(
                                data.product_type.canvas_design_areas
                            );
                        }
                        _this.isBusy = false;
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        _this.isBusy = false;
                        reject(response);
                    });
            });
        },
        getSingleProductData() {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.get(
                    "/home-single-newproduct/" +
                        this.$route.params.id_of_product
                )
                    .then(async ({ data }) => {
                        if (data.success == true && data.product != null) {
                            await this.getAllMarkupTiers();
                            await this.getDecorationMethods();

                            if (
                                JSON.parse(data.product.design_areas).length > 0
                            ) {
                                await this.getPrintArea(
                                    data.product.product_type_id
                                );
                                this.resetImprintLocations(
                                    JSON.parse(data.product.design_areas)
                                );
                            }

                            _this.decoration_services_show = true;

                            let decorations = JSON.parse(
                                data.product.decorations
                            );
                            _this.decoration_services = [];
                            if (decorations) {
                                decorations.forEach((decoration) => {
                                    if (decoration.decoration_type == "1") {
                                        _this.print_templates_id =
                                            decoration.decoration_price_template;
                                    }
                                    if (decoration.decoration_type == "2") {
                                        _this.embroidery_template_ids =
                                            decoration.decoration_price_template;
                                    }
                                    if (decoration.decoration_type == "3") {
                                        _this.promotional_template_ids =
                                            decoration.decoration_price_template;
                                    }

                                    let decoration_type_data =
                                        this.decoration_methods.find(
                                            (method) =>
                                                method.id ==
                                                decoration.decoration_type
                                        );
                                    _this.decoration_services.push({
                                        id: decoration.decoration_type,
                                        decoration_price_template:
                                            decoration.decoration_price_template,
                                        name: decoration_type_data
                                            ? decoration_type_data.name
                                            : "",
                                        more_decorations:
                                            decoration.more_decoration,
                                        price_decoration_bulk:
                                            decoration.price_decoration_bulk,
                                        isActive: decoration.default,
                                        price_dark: decoration.price_dark || 0,
                                        price_light: decoration.price_light || 0
                                    });
                                });
                            } else {
                                let decoration_type_data =
                                    this.decoration_methods.find(
                                        (method) =>
                                            method.id ==
                                            data.product.decoration_type
                                    );
                                /* eslint-disable */
                                _this.decoration_services.push({
                                    id: data.product.decoration_type,
                                    decoration_price_template:
                                        decoration.decoration_price_template,
                                    name: decoration_type_data
                                        ? decoration_type_data.name
                                        : "",
                                    more_decorations: JSON.parse(
                                        data.product.more_decoration
                                    ),
                                    price_decoration_bulk: JSON.parse(
                                        data.product.price_decoration_bulk
                                    ),
                                    isActive: true,
                                    price_dark:
                                        data.product
                                            .price_color_category_dark || 0,
                                    price_light:
                                        data.product
                                            .price_color_category_light || 0
                                });
                                /* eslint-enable */
                            }

                            _this.temp_decoration_services = JSON.parse(
                                JSON.stringify(_this.decoration_services)
                            );

                            var thumb_array = [];
                            var normal_array = [];

                            if (this.is_tshirt_24_hour) {
                                data.product.NewSubProducts =
                                    data.product.NewSubProducts.filter(
                                        (sub_product_data) =>
                                            sub_product_data.Color.name ==
                                            "White"
                                    );
                            }

                            _this.product = data.product;

                            _this.product.price_decoration_bulk = JSON.parse(
                                _this.product.price_decoration_bulk
                            );

                            // FETCHING LATEST PRICES FROM DECORATION TEMPLATES
                            if (
                                data.product.decoration_price_type ==
                                "global_price"
                            ) {
                                await this.$store
                                    .dispatch(FETCH_DECORATION_PRICES, {
                                        decoration_type:
                                            data.product.decoration_type,
                                        decoration_price_template_id:
                                            data.product
                                                .decoration_price_template
                                    })
                                    .then(() => {
                                        _this.product.price_decoration_bulk =
                                            _this.decorationPrices;
                                    });

                                if (_this.product.decoration_type === 1) {
                                    _this.product.price_decoration_bulk.no_of_colors =
                                        _this.product.PrintTemplate.no_of_colors;
                                    _this.product.price_color_category_dark =
                                        _this.product.PrintTemplate.price_dark;
                                    _this.product.price_color_category_light =
                                        _this.product.PrintTemplate.price_light;
                                } else if (
                                    _this.product.decoration_type === 2
                                ) {
                                    _this.product.price_color_category_dark =
                                        _this.product.Embroidery.price_dark;
                                    _this.product.price_color_category_light =
                                        _this.product.Embroidery.price_light;
                                }
                            }

                            _this.product.more_decoration = JSON.parse(
                                _this.product.more_decoration
                            );
                            let sorted_size_names = this.sizesArrangmentSorting(
                                _this.product.NewSubProducts.map(
                                    (s) => s.Size.size
                                )
                            );
                            let sorted_sub_products = [];
                            sorted_size_names.forEach((sorted_size_name) => {
                                _this.product.NewSubProducts.forEach(
                                    (new_sub_product) => {
                                        if (
                                            new_sub_product.Size.size ==
                                            sorted_size_name
                                        ) {
                                            sorted_sub_products.push(
                                                new_sub_product
                                            );
                                        }
                                    }
                                );
                            });
                            _this.product.NewSubProducts = sorted_sub_products;

                            //if video url in product table
                            if (
                                data.product.video_url &&
                                data.product.video_url.trim() != ""
                            ) {
                                thumb_array.push({
                                    id: data.product.id,
                                    url: data.product.video_url,
                                    thumb_url: data.product.video_url,
                                    type: "video"
                                });
                                normal_array.push({
                                    id: data.product.id,
                                    url: data.product.video_url,
                                    type: "video"
                                });
                            }

                            //decoration type
                            _this.decoration_type =
                                data.product.decoration_type;
                            this.loadVendorColors(data.product);

                            //gender and colors
                            _this.groupedSizesByColors =
                                _this.groupArrayOfObjects(
                                    _this.product.NewSubProducts,
                                    "color_id"
                                );
                            Object.values(_this.groupedSizesByColors).forEach(
                                (element) => {
                                    let lowest_price = 0;
                                    element.forEach((size, i) => {
                                        let base_price = size.price_base
                                            ? size.price_base
                                            : 0;
                                        if (parseFloat(base_price) > 0) {
                                            if (i == 0) {
                                                lowest_price =
                                                    parseFloat(base_price);
                                            } else if (
                                                parseFloat(lowest_price) >
                                                parseFloat(base_price)
                                            ) {
                                                lowest_price =
                                                    parseFloat(base_price);
                                            }
                                        }
                                    });
                                    _this.colors.push({
                                        id: element[0].Color.id,
                                        color_name: element[0].Color.name,
                                        hash: element[0].Color.hex,
                                        pms: element[0].Color.pms,
                                        swatches: element[0].Color.swatches,
                                        shades: element[0].Color.shades,
                                        category: element[0].Color.category,
                                        default_selection:
                                            element[0].default_selection,
                                        price_base: lowest_price
                                    });
                                }
                            );

                            // STORE DEFAULT COLOR
                            if (!this.is_tshirt_24_hour) {
                                _this.default_selected_color =
                                    _this.colors.find(
                                        (color) => color.default_selection == 1
                                    );
                            } else {
                                _this.default_selected_color = _this.colors[0];
                            }

                            _this.product.price_base =
                                _this.default_selected_color.price_base;
                            _this.product.price_markup_value =
                                (parseFloat(_this.product.price_base) *
                                    parseFloat(
                                        _this.product.price_markup_percentage
                                    )) /
                                100;

                            _this.retail_price_without_price_template =
                                _this.product.price_base +
                                _this.product.price_markup_value;

                            //    Decoration
                            this.prepareDecorationPrices(
                                this.product.decoration_type,
                                this.product.price_decoration_bulk
                            );

                            await _this.getMoreDecorations(
                                _this.product.more_decoration
                            );

                            if (!_this.is_tshirt_24_hour) {
                                _this.getProductImages();
                            } else {
                                _this.getProductImages(_this.colors[0].id);
                            }

                            // if (_this.decoration_method_template_ids) {
                            //     _this.getDecorationPriceFromTemplateIds();
                            // }

                            //genders group
                            var gendersGroup = JSON.parse(
                                data.product.size_groupings
                            );

                            _this.getGendersGroups(gendersGroup).then(() => {
                                setTimeout(() => {
                                    if (_this.default_selected_color) {
                                        document
                                            .getElementById(
                                                `gender_${this.gender_groups[0].id}_color_${_this.default_selected_color.id}`
                                            )
                                            .click();
                                    }
                                    _this.isBusy = false;
                                }, 1000);
                            });
                            _this.getCompanionProduct(
                                this.$route.params.id_of_product
                            );
                        }
                    })
                    .catch((response) => {
                        _this.isBusy = false;
                        console.log(response);
                        this.$toast.error(response, {
                            position: "top-right",
                            queue: true
                        });
                    });
            });
        },

        updateDecorationDiscountedPrice(data, decoration_type) {
            if (decoration_type == 1) {
                if (data.print_location1) {
                    data.print_location1.forEach((row) => {
                        for (
                            let i = 1;
                            i < this.product.PrintTemplate.no_of_colors;
                            i++
                        ) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }
            } else if (decoration_type == 2) {
                data.forEach((row) => {
                    let discount_value =
                        (parseFloat(row["cost"]) * parseFloat(row.discount)) /
                        100;
                    row["cost"] = parseFloat(
                        parseFloat(row["cost"]) - parseFloat(discount_value)
                    ).toFixed(2);
                });
            }
            return data;
        },

        deleteImages(image_id) {
            let ids = [];
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ids.push(image_id);
                    ApiService.post("/delete_userimages", { ids: ids })
                        .then(() => {
                            this.uploadedImages = [];
                            this.UploadedImages();
                            /* eslint-disable */
                            $(".new_artwork_popup").modal("hide");
                            /* eslint-enable */
                            this.$toast.success("Image deleted successfully", {
                                position: "top-right",
                                queue: true
                            });
                        })
                        .catch(({ response }) => {
                            //  console.log(response.status);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },

        previewArtworkImages(images) {
            this.preview_artwork_images = images;
            /* eslint-disable */
            if (
                this.getUrlExtension(images) == "ai" ||
                this.getUrlExtension(images) == "eps"
            ) {
                $("#preview_modals").modal("hide");
                // window.open(this.preview_artwork_images, '_blank');
                this.downloadURI(this.preview_artwork_images, this.images_name);
                this.$toast.success("Files downloaded successfully", {
                    position: "top-right",
                    queue: true
                });
                return;
            }
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        cancelPreviewImages() {
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        downloadURI(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        getsizeByColor(color_obj, event = null) {
            if (!event || !event.target.checked) {
                let selected_colors =
                    this.gender_groups[this.is_active]["selected_colors"];

                if (selected_colors && selected_colors.length) {
                    this.gender_groups[this.is_active]["selected_colors"] =
                        selected_colors.filter(
                            (color) => color.id != color_obj.id
                        );
                    let color_index = this.colors.findIndex(
                        (color) => color.id == color_obj.id
                    );
                    this.colors[color_index].is_selected = false;
                }

                if (
                    this.gender_groups[this.is_active].total_qty_gender_wise ==
                        0 &&
                    selected_colors.length == 0
                ) {
                    this.resetValues();
                }

                if (
                    this.gender_groups[this.is_active]["selected_colors"]
                        .length == 0
                ) {
                    this.choose_imprint_locations = false;
                    this.resetImprintLocations(
                        JSON.parse(this.product.design_areas)
                    );
                }

                this.calculatePricing(this.is_active);
                this.$forceUpdate();

                return;
            }

            let image = this.product.NewProductImages.find(
                (productImage) => productImage.color_id == color_obj.id
            );

            if (image && image.url) {
                color_obj["product_image"] = image.url;
            }

            this.selected_color = color_obj;
            let selected_gender = this.gender_groups[this.is_active];
            let sizes = [];
            sizes.push(
                selected_gender.sizes.filter(function (size) {
                    return size.color_id === color_obj.id;
                })
            );
            let sizesby_selected_color = [].concat.apply([], sizes);
            let new_sizeby_selected_color_array = [];
            sizesby_selected_color.forEach((element) => {
                if (element.status) {
                    // element.single_location_price = this.minimum_quantity_decoration_fee
                    new_sizeby_selected_color_array.push(element);
                }
            });
            this.sizesby_selected_color = new_sizeby_selected_color_array;

            let colorObj = JSON.parse(JSON.stringify(color_obj));
            colorObj["unique_sizes"] = JSON.parse(
                JSON.stringify(this.sizesby_selected_color)
            );
            colorObj["total_cost_gender_wise"] = 0;
            colorObj["total_qty_gender_wise"] = 0;
            colorObj["total_color_fee"] = 0;
            colorObj["total_dark_category_fee"] = 0;
            colorObj["total_light_category_fee"] = 0;
            colorObj["total_decoration_discount_value"] = 0;
            if (!this.gender_groups[this.is_active]["selected_colors"]) {
                this.gender_groups[this.is_active]["selected_colors"] = [
                    colorObj
                ];
            } else {
                let color_index = this.gender_groups[this.is_active][
                    "selected_colors"
                ].findIndex((color) => color.id == colorObj.id);
                if (color_index < 0) {
                    this.gender_groups[this.is_active]["selected_colors"].push(
                        colorObj
                    );
                }
            }

            if (
                this.gender_groups[this.is_active]["selected_colors"].length > 0
            ) {
                this.choose_imprint_locations = true;
            }

            this.calculatePricing(this.is_active);

            this.onChangeGenderColor();
        },

        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ["color_name", "color_value"],
                shouldSort: true
            });
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list;
        },

        //croppie function start
        bind() {
            // Randomize cat photos, nothing special here.
            /* eslint-disable */
            let url = this.images[Math.floor(Math.random() * 4)];
            /* eslint-enable */
            // Just like what we did with .bind({...}) on
            // the mounted() function above.
            this.$refs.croppieRef.bind({
                url: "/maincss/design-studio/img/design-st-upload.jpg",
                zoom: 0
            });
        },

        cropViaEvent() {
            /* eslint-disable */
            this.$refs.croppieRef.result(options);
            /* eslint-enable */
        },

        result(output) {
            this.cropped = output;
        },

        update(val) {
            console.log(val);
        },

        rotate(rotationAngle) {
            // Rotates the image
            this.$refs.croppieRef.rotate(rotationAngle);
        },

        croppie(e) {
            var _this = this;
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            _this.image_size_validation = 0;
            this.image_size = files[0].size / (1024 * 1024);
            // console.log('check for svg images here==========', files[0]['type']);
            if (
                files[0]["type"] != "image/jpeg" &&
                files[0]["type"] != "image/png" &&
                files[0]["type"] != "image/jpg" &&
                files[0]["type"] != "image/svg+xml" &&
                files[0]["type"] != "application/pdf" &&
                files[0]["type"] != "application/postscript"
            ) {
                this.crop_image_validation = 1;
                console.log(
                    "Incorrect image format.Please upload the Png, Jpg, Jpeg, svg, pdf, ai, eps file formats"
                );
                $("#crop_bdr").val("");
                this.croppieImage = null;
                this.images_name = "";
                // this.$refs.croppieRef.refresh();

                //load default image in croptool
                // this.$refs.croppieRef.bind({
                //     url: '/maincss/design-studio/img/design-st-upload.jpg'
                // });
            } else {
                _this.crop_image_validation = 0;
                _this.image_size_validation = 0;

                var reader = new FileReader();
                reader.onload = (e) => {
                    var image = new Image();
                    image.src = e.target.result;
                    $(".cr-slider").prop("disabled", true);
                    $("#crop_btn").prop("disabled", false);
                    this.croppieImage = e.target.result;
                    this.images_name = files[0]["name"];
                    image.onload = function () {
                        _this.image_height = this.height;
                        _this.image_width = this.width;
                        if (
                            _this.image_height < 100 &&
                            _this.image_width < 100
                        ) {
                            _this.crop_image_validation = 0;
                        } else {
                            _this.image_height = "";
                            _this.image_width = "";
                            _this.image_size_validation = 0;
                        }
                    };
                };
            }
            /* eslint-enable */

            reader.readAsDataURL(files[0]);
        },

        crop() {
            // Options can be updated.
            // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
            this.image_width = 200;
            this.image_height = 200;
            this.image_uploaded = {
                image: this.croppieImage,
                name: this.images_name,
                size: this.image_size.toFixed(2) + "MB",
                dimension: this.image_width + "x" + this.image_height
            };
            this.uploadedImages.push({ image_path: this.croppieImage });
            if (this.uploadedImages.length == 1) {
                this.temp_product_artwork = this.croppieImage;
            }
            this.NewImageUploads();
            /* eslint-disable */
            $("#crop_modal").modal("hide");
            $("#crop_bdr").val("");
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        uploadArtWork() {
            /* eslint-disable */
            let val = $("#crop_bdr").val();
            this.croppieImage = null;
            this.images_name = null;
            if (!val) {
                $("#crop_btn").prop("disabled", true);
            } else {
                $("#crop_btn").prop("disabled", false);
            }
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        cancelUploadArtwork() {
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        addArtWorkModal() {
            // let decoration_template;
            // if (this.decoration_type == 1) {
            //     decoration_template = this.decoration_price_template_values[0].quantity;
            // } else if (this.decoration_type == 2) {
            //     decoration_template = this.decoration_price_template_values[0].quantity1;
            // }
            // // let color_names = [];
            // let color_names = [];
            // let error = false;
            // let gender_total_quantity = 0;
            // this.gender_groups.forEach(gender => {
            //     gender.selected_colors.forEach(color => {
            //         if (!color.total_qty_gender_wise) {
            //             color_names.push(color.color_name)
            //             error = true;
            //         }
            //         // if (
            //         //     parseInt(color.total_qty_gender_wise) <
            //         //     parseInt(decoration_template)
            //         // ) {
            //         //     color_names.push(color.color_name)
            //         //     error = true;
            //         // }
            //     })
            //     gender_total_quantity+=gender.total_qty_gender_wise;
            // })

            // if (error) {
            //     // this.$toast.error(`${color_names.join(',')} quantity should be equal or greater than ${decoration_template}`, { position: "top-right", queue: true });
            //     this.$toast.error(`${color_names.join(',')}  atleast one single quantity is required`, { position: "top-right", queue: true });
            //     return;
            // }

            // if (gender_total_quantity < decoration_template) {
            //     this.$toast.error(`Quantity should be greater than or equal to ${decoration_template}`,  { position: "top-right", queue: true });
            //     return;
            // }
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        //croppie function end
        artworkDone() {
            if (this.temp_product_artwork) {
                this.product_artwork = this.temp_product_artwork;

                this.updateCartQuantity(true);
                return;
            }
            this.removeArtwork();

            this.updateCartQuantity(true);
        },

        removeArtwork() {
            this.product_artwork = "";
            this.temp_product_artwork = "";
            // this.removeSetupFee();
        },

        removeSetupFee() {
            if (this.setup_fee_applied_gender_index >= 0) {
                let gender =
                    this.gender_groups[this.setup_fee_applied_gender_index];
                if (gender.total_cost_gender_wise != 0) {
                    gender.total_cost_gender_wise =
                        parseFloat(gender.total_cost_gender_wise) -
                        gender["selected_colors"][0].setup_fee;
                    gender["selected_colors"][0].total_cost_gender_wise =
                        parseFloat(
                            gender["selected_colors"][0].total_cost_gender_wise
                        ) - gender["selected_colors"][0].setup_fee;
                }
                gender["selected_colors"][0].setup_fee = 0.0;
            }
            this.setup_fee = false;
            this.setup_fee_applied_gender_index = -1;
        },

        UploadedImages() {
            this.uploadedImages = [];
            new Promise(() => {
                ApiService.post("/userimages")
                    .then(({ data }) => {
                        this.uploadedImages = data.userImages.filter((image) =>
                            this.isValidHttpUrl(image.image_path)
                        );
                    })
                    .catch(({ response }) => {
                        //  console.log(response.status);
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        NewImageUploads() {
            console.log(this.temp_product_artwork);
            if (this.image_uploaded) {
                var _this = this;
                _this.isBusy = true;
                new Promise(() => {
                    ApiService.post("/image_upload", this.image_uploaded)
                        .then(({ data }) => {
                            _this.isBusy = false;

                            if (data.success == false) {
                                _this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                return false;
                            }
                            _this.temp_product_artwork = data.image.image_path;
                            _this.image_uploaded = null;
                            if (_this.$refs.fileInput) {
                                _this.$refs.fileInput.value = null;
                            }
                            // _this.UploadedImages();
                            _this.artworkDone();
                            // $("#add-art-work").modal("hide");
                        })
                        .catch((response) => {
                            _this.isBusy = false;
                            _this.$toast.error(response, {
                                position: "top-right",
                                queue: true
                            });
                            console.log(response);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },

        resetValues() {
            this.removeArtwork();
            this.removeSetupFee();
            this.disable_btns = true;
            this.gender_groups.forEach((gender) => {
                gender["total_cost_gender_wise"] = 0.0;
                gender["selected_colors"] = [];
                gender["total_color_fee"] = 0.0;
                gender["total_qty_gender_wise"] = 0.0;
            });
            this.colors.forEach((color) => {
                color.is_selected = false;
            });

            this.imprint_locations = [];
            if (JSON.parse(this.product.design_areas).length > 0) {
                this.resetImprintLocations(
                    JSON.parse(this.product.design_areas)
                );
            }

            this.hashcolor = [];
            this.current_cart_quantity = 0;
        },

        resetImprintLocations(design_areas) {
            this.imprint_locations = [];
            design_areas.forEach((area) => {
                if (area.selected) {
                    let selectedArea = this.print_areas.filter((printArea) => {
                        return printArea.label == area.label;
                    });
                    this.imprint_locations.push({
                        location: area.label_show.trim() || area.label.trim(),
                        image_path:
                            selectedArea.length > 0
                                ? selectedArea[0].short_thumbnail_image
                                : area.short_thumbnail_image,
                        is_selected: false,
                        no_of_color: null,
                        price: 0,
                        total_price: 0,
                        colors: []
                    });
                }
            });
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        // This function not using
        addTocart() {
            var _this = this;

            let is_colors_empty = false;
            let is_locations_selected = false;
            let is_area_colors_empty = false;
            for (let location of _this.imprint_locations) {
                if (location.is_selected) {
                    is_locations_selected = true;
                    if (location.colors.length == 0) {
                        is_area_colors_empty = true;
                        break;
                    } else {
                        let is_selected = location.colors.find(
                            (color) => color.color == null
                        );
                        if (is_selected) {
                            is_colors_empty = true;
                            break;
                        }
                    }
                }
            }

            let errorText = "";
            if (_this.product.decoration_type == 1) {
                errorText = "imprint locations";
            } else if (_this.product.decoration_type == 2) {
                errorText = "embroidery locations";
            }

            if (!is_locations_selected) {
                _this.$toast.error(`Please select ${errorText}.`, {
                    position: "top-right",
                    queue: true
                });
                return;
            } else if (is_colors_empty) {
                _this.$toast.error(
                    `Please select all imprint colors for selected ${errorText}.`,
                    { position: "top-right", queue: true }
                );
                return;
            } else if (is_area_colors_empty) {
                _this.$toast.error(
                    `Please select colors for selected ${errorText}.`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (!this.product_artwork) {
                _this.$toast.error("Please Select or Upload Artwork", {
                    position: "top-right",
                    queue: true
                });
                return;
            }

            let minimum_quantity;
            if (this.decoration_type == 1) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity;
            } else if (this.decoration_type == 2) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity1;
            }
            // let color_names = [];
            let color_names = [];
            let is_color_quantity_empty = false;
            let gender_total_quantity = 0;
            this.gender_groups.forEach((gender) => {
                gender.selected_colors.forEach((color) => {
                    if (!color.total_qty_gender_wise) {
                        color_names.push(color.color_name);
                        is_color_quantity_empty = true;
                    }
                });
                gender_total_quantity += gender.total_qty_gender_wise;
            });

            if (is_color_quantity_empty) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )}  atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (
                gender_total_quantity + this.current_cart_quantity <
                minimum_quantity
            ) {
                this.$toast.error(
                    `Quantity should be greater than or equal to ${minimum_quantity}`,
                    { position: "top-right", queue: true }
                );
                return;
            }
            _this.addIncart();
        },

        // This function not using
        addIncart() {
            var _this = this;
            let selectedProductQty = [];
            let allitems = [];

            if (_this.gender_groups) {
                selectedProductQty = _this.gender_groups.filter(
                    (element) => element.total_qty_gender_wise > 0
                );
            }

            if (selectedProductQty) {
                selectedProductQty.forEach((element) => {
                    element["selected_colors"].forEach((color) => {
                        let items = [];
                        color["unique_sizes"].forEach((size) => {
                            items.push({
                                sub_product_id: size.id,
                                user_id: _this.currentUserClient.id,
                                case_price: size.price_base,
                                markup_price: size.markup_price,
                                markup_percentage:
                                    _this.product.price_markup_percentage,
                                ink_price: size.ink_price || 0,
                                single_location_price:
                                    size.single_location_price || 0,
                                quantity: size.quantity || 0,
                                discount: size.discount ? size.discount : 0.0,
                                unit_price: size.cost || 0,
                                total_price: size.total_cost || 0
                            });
                            // }
                        });

                        allitems.push({
                            user_id: _this.currentUserClient.id,
                            item_id: _this.product.id,
                            gender_size_id: element.id,
                            color_id: color.id,
                            product_image: color.product_image,
                            decoration_type: _this.product.decoration_type,
                            price_decoration_bulk:
                                _this.product.price_decoration_bulk,
                            more_decorations: _this.product.more_decoration,
                            items: items,
                            imprint_locations: color.imprint_locations,
                            total_design_fee: color.total_design_fee,
                            total_dark_category_fee:
                                color.total_dark_category_fee,
                            total_light_category_fee:
                                color.total_light_category_fee,
                            total_quantity: color.total_qty_gender_wise,
                            total_price: color.total_cost_gender_wise,
                            setup_fee: color.setup_fee ? color.setup_fee : 0.0,
                            imprint_locations_price: color.total_color_fee,
                            subtotal_price: color.total_cost_gender_wise,
                            artwork: _this.product_artwork
                        });
                    });
                });
            }
            if (_this.currentUserClient.id) {
                _this.isBusy = true;
                new Promise(() => {
                    ApiService.post("/add-to-cart", allitems)
                        .then(async ({ data }) => {
                            if (!data.success) {
                                _this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                _this.isBusy = false;
                                return;
                            }
                            await _this.updateCartItems();
                            _this.$toast.success(
                                "Product has been added into the cart successfully.",
                                { position: "top-right", queue: true }
                            );
                            _this.$root.$emit("update-cart", {
                                type: "success"
                            });
                            /* eslint-disable */
                            $("#add-art-work").modal("hide");
                            /* eslint-enable */
                            _this.resetValues();
                            _this.getCartItems();

                            // setTimeout(() => {
                            //     let default_selected_color = this.colors.find(color => color.default_selection == 1);
                            //     if (default_selected_color) {
                            //         document.getElementById(`gender_${this.gender_groups[0].id}_color_${default_selected_color.id}`).click();
                            //     }
                            // }, 100);
                            _this.isBusy = false;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
            } else {
                selectedProductQty.filter((element) => {
                    let items = [];
                    let total_quantity = 0;
                    let total_price = 0;
                    let color_id = "";
                    element["unique_sizes"].forEach((elem) => {
                        if (elem.quantity > 0) {
                            total_quantity =
                                total_quantity + parseInt(elem.quantity);
                            total_price =
                                total_price + parseFloat(elem.total_cost);
                            color_id = elem.color_id;
                            items.push({
                                sub_product_id: elem.id,
                                user_id: _this.currentUserClient.id,
                                quantity: elem.quantity,
                                unit_price: elem.cost,
                                total_price: elem.total_cost,
                                sub_prodcut: elem
                            });
                        }
                    });
                    allitems.push({
                        user_id: _this.currentUserClient.id,
                        item_id: _this.product.id,
                        gender_size_id: element.id,
                        color_id: color_id,
                        imprint_locations: _this.imprint_locations,
                        total_quantity: total_quantity,
                        total_price: total_price,
                        artwork: _this.product_artwork,
                        product: _this.product,
                        Genderagesize: element,
                        CartChildItems: items
                    });
                });
                localStorage.setItem("cart", JSON.stringify(allitems));
                console.log("completed storing in the local database");
                _this.$toast.success(
                    "Product has been added into the cart successfully.",
                    { position: "top-right" }
                );
                _this.$root.$emit("update-cart", { type: "success" });
                _this.resetValues();
                _this.isBusy = false;
            }
        },

        // This function not using
        updateCartItems() {
            let params = [];
            this.same_artwork_cart_items.forEach((item) => {
                let child_items = [];
                item.CartChildItems.forEach((childItem) => {
                    child_items.push({
                        id: childItem.id,
                        sub_product_id: childItem.sub_product_id,
                        case_price: childItem.case_price,
                        markup_price: childItem.markup_price,
                        markup_percentage: childItem.markup_percentage,
                        ink_price: childItem.ink_price,
                        single_location_price: childItem.single_location_price,
                        quantity: childItem.quantity || 0,
                        discount: childItem.discount || 0,
                        unit_price: childItem.unit_price || 0,
                        total_price: childItem.total_price || 0
                    });
                });
                params.push({
                    cart_id: item.id,
                    child_items: child_items,
                    total_dark_category_fee: item.total_dark_category_fee,
                    total_light_category_fee: item.total_light_category_fee,
                    name_number_fees: item.name_number_fees,
                    non_standard_fees: item.non_standard_fees,
                    imprint_locations_price: item.imprint_locations_price,
                    imprint_locations: item.imprint_locations,
                    total_quantity: item.total_quantity,
                    subtotal_price: item.subtotal_price,
                    total_price: item.total_price
                });
            });

            return new Promise((resolve, reject) => {
                ApiService.post("/update-cart", params)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                        }
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        openStartDesignModal() {
            let minimum_quantity;

            let total_qty = 0;
            let error = false;
            let color_names = [];
            this.gender_groups.forEach((gender) => {
                if (gender.selected_colors) {
                    gender.selected_colors.forEach((color) => {
                        if (!color.total_qty_gender_wise) {
                            color_names.push(color.color_name);
                            error = true;
                        }
                    });
                }

                total_qty = total_qty + gender.total_qty_gender_wise;
            });

            if (this.decoration_type == 1) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity;
            } else if (this.decoration_type == 2) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity1;
            }

            if (error) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )} atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (total_qty == 0) {
                this.$toast.error(
                    "Please select color and quantity to design",
                    { position: "top-right", queue: true }
                );
                return;
            } else if (parseInt(total_qty) < parseInt(minimum_quantity)) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let is_locations_selected = false;
            let is_area_colors_empty = false;
            for (let location of this.imprint_locations) {
                if (location.is_selected) {
                    is_locations_selected = true;
                    if (location.colors.length == 0) {
                        is_area_colors_empty = true;
                        break;
                    }
                }
            }

            let errorText = "";
            if (this.product.decoration_type == 1) {
                errorText = "imprint locations";
            } else if (this.product.decoration_type == 2) {
                errorText = "embroidery locations";
            }

            if (!is_locations_selected) {
                this.$toast.error(`Please select ${errorText}.`, {
                    position: "top-right",
                    queue: true
                });
                return;
            } else if (is_area_colors_empty) {
                this.$toast.error(
                    `Please select colors for selected ${errorText}.`,
                    { position: "top-right", queue: true }
                );
                return;
            }
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        startDesign() {
            var _this = this;
            let cart = [];
            /* eslint-disable */
            $("#add-art-work").modal("hide");
            /* eslint-enable */
            let decoration_template;
            let total_qty = 0;
            let error = false;
            let color_names = [];
            _this.gender_groups.forEach((gender) => {
                if (gender.selected_colors) {
                    gender.selected_colors.forEach((color) => {
                        if (!color.total_qty_gender_wise) {
                            color_names.push(color.color_name);
                            error = true;
                        }
                    });
                }

                total_qty = total_qty + gender.total_qty_gender_wise;
            });
            if (_this.decoration_type == 1) {
                decoration_template =
                    _this.decoration_price_template_values[0].quantity;
            } else if (_this.decoration_type == 2) {
                decoration_template =
                    _this.decoration_price_template_values[0].quantity1;
            }

            if (error) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )} atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (total_qty == 0) {
                let error_message =
                    "Please select color and quantity to design";
                _this.$toast.error(error_message, {
                    position: "top-right"
                });
            } else if (parseInt(total_qty) < parseInt(decoration_template)) {
                _this.error_message =
                    "Quantity should be greater than or equal to " +
                    decoration_template;
                _this.$toast.error(_this.error_message, {
                    position: "top-right",
                    queue: true
                });
            } else {
                //  colors fee
                let colors_cost = 0;

                let setup_fee = 0;

                // if (selectedProductQty) {
                this.gender_groups.forEach((gender) => {
                    if (gender.total_qty_gender_wise > 0) {
                        let selected_colors = [];

                        gender["selected_colors"].forEach((color) => {
                            let quantity = color["unique_sizes"].find(
                                (size) => size.quantity > 0
                            );
                            if (quantity) {
                                color.setup_fee = setup_fee;
                                selected_colors.push(color);
                            }
                        });

                        if (selected_colors.length > 0) {
                            cart.push({
                                item: _this.product,
                                color: selected_colors[0],
                                colors: selected_colors,
                                gender_name: gender.gender,
                                gender_id: gender.id,
                                base_price: _this.product.price_base,
                                total_qty: gender.total_qty_gender_wise,
                                subtotal: gender.subtotal,
                                total_color_fee: 0,
                                total_cost:
                                    gender.total_cost_gender_wise -
                                    gender.total_color_fee, // We removing color fee because in design studio without selecting colors we dont need to show location fees
                                total_design_fee: gender.total_design_fee,
                                total_discount_value:
                                    gender.total_discount_value,
                                total_setup_fee:
                                    _this.product.decoration_type == 2
                                        ? this.setup_fee
                                        : 0.0,
                                imprint_locations_price: colors_cost
                                    ? colors_cost.toFixed(2)
                                    : 0.0,
                                imprint_locations: _this.imprint_locations,
                                artwork: _this.product_artwork,
                                markup_percentage:
                                    _this.product.price_markup_percentage
                            });
                        }
                    }
                });
                // }
                //console.log('check cart value', cart);
                localStorage.setItem("design", JSON.stringify(cart));
                localStorage.setItem("is24Tshirt", this.is_tshirt_24_hour);
                localStorage.setItem("colorIndex", 0);
                /* eslint-disable */
                $("#design-confirmation-modal").modal("hide");
                /* eslint-enable */
                let hashValue = "";
                if (this.start_designing_with == "existing") {
                    hashValue = "#designs";
                } else if (this.start_designing_with == "upload") {
                    hashValue = "#upload";
                }
                this.$router.push({ name: "DesignStudioV3", hash: hashValue });
            }
        },

        // This function not using
        resetAllImprintLocationsData() {
            this.imprint_locations.forEach((locations) => {
                locations.colors = [];
                locations.is_selected = false;
                locations.price = 0;
                locations.total_price = 0;
                locations.no_of_color = null;
            });
        },

        selectImprintLocations(index) {
            if (this.imprint_locations[index].is_selected) {
                this.imprint_locations[index].no_of_color = null;
                this.imprint_locations[index].colors = [];
            }
            this.imprint_locations[index].is_selected =
                !this.imprint_locations[index].is_selected;
            this.calculatePricing(this.is_active);
            this.$forceUpdate();
        },

        selectNumberOfColors(location, count) {
            let no_of_colors = parseInt(count) || 0;
            location.no_of_color = parseInt(count) || null;
            location.colors = [];
            for (let i = 0; i < no_of_colors; i++) {
                location.colors.push({
                    color: null,
                    color_cost: 0.0,
                    cost_cost: 0.0,
                    cost_sum_added: false
                });
            }
            this.calculatePricing(this.is_active);
        },

        calcImprintLocationByGender() {
            let initalLocationIndex = 0;
            let total_gender_quantity = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );
            this.total_decoration_colors_count = 0;
            if (this.product.decoration_type == 1) {
                this.imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initalLocationIndex == 0 && no_of_colors == 1) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else if (no_of_colors > 0) {
                            let decoration_price = this.getDecorationPrice(
                                no_of_colors - 1,
                                undefined,
                                initalLocationIndex > 0
                            );
                            let color1_decoration_price =
                                this.getDecorationPrice(
                                    0,
                                    undefined,
                                    initalLocationIndex > 0
                                );
                            location.decoration_fee =
                                parseFloat(decoration_price);
                            if (initalLocationIndex == 0) {
                                location.decoration_fee =
                                    parseFloat(location.decoration_fee) -
                                    parseFloat(color1_decoration_price);
                            }
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_gender_quantity;
                        }
                        initalLocationIndex++;
                        this.total_decoration_colors_count += no_of_colors;
                    }
                });
            } else if (this.product.decoration_type == 2) {
                this.imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initalLocationIndex == 0) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else if (no_of_colors > 0) {
                            let decoration_price = this.getDecorationPrice(
                                0,
                                initalLocationIndex
                            );
                            location.decoration_fee =
                                parseFloat(decoration_price);
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_gender_quantity;
                        }
                        initalLocationIndex++;
                        this.total_decoration_colors_count += no_of_colors;
                    }
                });
            }
        },

        getTotalItemQuantity(gender_element) {
            let total_quantity = 0;
            gender_element.selected_colors.forEach((color) => {
                color.unique_sizes.forEach((size) => {
                    if (size.quantity > 0) {
                        total_quantity += parseInt(size.quantity);
                    }
                });
            });
            return total_quantity;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        calculatePricing(index, size, event = null) {
            var _this = this;
            if (event && event.target.value > _this.max_cart_count) {
                let error_message =
                    "Quantity should not be greater than " +
                    _this.max_cart_count;
                _this.$toast.error(error_message, {
                    position: "top-right",
                    queue: true
                });
                event.target.value = 0;
                size.quantity = null;
            } else {
                if (_this.decoration_type == 1) {
                    _this.calculatePrintPricing(index);
                } else if (_this.decoration_type == 2) {
                    _this.calculateEmbroideryPricing(index);
                }

                // Check Qty
                this.xl_has_quantity = false;
                let total_qty = 0;
                _this.gender_groups.forEach((csq) => {
                    total_qty = total_qty + csq.total_qty_gender_wise;

                    // CHECKING IF XL SIZE HAVE QUANTITY
                    csq.selected_colors.forEach((color) => {
                        color.unique_sizes.forEach((size) => {
                            if (
                                size.Size &&
                                size.Size.size.includes("XL") &&
                                size.Size.size.length > 2 &&
                                size.quantity > 0
                            ) {
                                this.xl_has_quantity = true;
                            }
                        });
                    });
                });
                _this.disable_btns = total_qty == 0;
            }
        },

        calculatePrintPricing(index) {
            let gender_element = this.gender_groups[index];

            gender_element.total_discount_value = 0;
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_dark_category_fee = 0;
            gender_element.total_light_category_fee = 0;
            gender_element.subtotal = 0;
            this.setup_fee = 0;
            if (gender_element["selected_colors"]) {
                let single_location_price = this.getDecorationPrice();
                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        selected_color_obj.total_discount_value = 0;
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.total_cost_gender_wise = 0;
                        selected_color_obj.total_design_fee = 0;
                        selected_color_obj.total_color_fee = 0;
                        selected_color_obj.total_dark_category_fee = 0;
                        selected_color_obj.total_light_category_fee = 0;
                        selected_color_obj.setup_fee = 0;
                        selected_color_obj.subtotal = 0;

                        selected_color_obj["unique_sizes"].forEach((size) => {
                            if (
                                this.product.decoration_price_type ==
                                "global_price"
                            ) {
                                this.product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        this.product.price_base,
                                        this.product.decoration_type,
                                        this.product.decoration_price_template
                                    );
                                this.product.price_markup_value =
                                    (parseFloat(this.product.price_base) *
                                        parseFloat(
                                            this.product.price_markup_percentage
                                        )) /
                                    100;
                            }

                            let base_price = this.product.price_base;
                            let mark_up_cost = this.product.price_markup_value;
                            if (size.price_base > 0) {
                                base_price = size.price_base;
                                size.markup_percentage =
                                    this.product.price_markup_percentage;
                                if (
                                    this.product.decoration_price_type ==
                                    "global_price"
                                ) {
                                    size.markup_percentage =
                                        this.getMarkupFromTier(
                                            base_price,
                                            this.product.decoration_type,
                                            this.product
                                                .decoration_price_template
                                        );
                                }
                                mark_up_cost =
                                    (base_price * size.markup_percentage) / 100;
                            }

                            size.markup_price = mark_up_cost;

                            let color_category_price = 0;
                            if (selected_color_obj.category == "Dark") {
                                color_category_price =
                                    this.product.price_color_category_dark;
                                size.dark_price = color_category_price;
                                selected_color_obj.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            } else if (selected_color_obj.category == "Light") {
                                color_category_price =
                                    this.product.price_color_category_light;
                                size.light_price = color_category_price;
                                selected_color_obj.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            }

                            size.ink_price = parseFloat(color_category_price);
                            size.single_location_price = single_location_price;
                            if (
                                size.quantity != "undefined" &&
                                size.quantity > 0
                            ) {
                                size.cost = this.getRetailPrice({
                                    base_price: parseFloat(base_price),
                                    markup_price: parseFloat(mark_up_cost),
                                    single_location_price: parseFloat(
                                        size.single_location_price
                                    ),
                                    color_category_price:
                                        parseFloat(color_category_price)
                                });

                                if (this.product.NewProductDiscount !== null) {
                                    let discount_type =
                                        this.product.NewProductDiscount
                                            .discount_type;
                                    let discount_value = parseFloat(
                                        this.product.NewProductDiscount
                                            .discount_value
                                    );
                                    let single_quantity_discount = 0;
                                    if (discount_type == "Percent") {
                                        single_quantity_discount =
                                            (size.cost * discount_value) / 100;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    } else {
                                        single_quantity_discount =
                                            discount_value;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    }
                                    selected_color_obj.total_discount_value +=
                                        parseFloat(size.discount);
                                    selected_color_obj.total_discount_value =
                                        parseFloat(
                                            selected_color_obj.total_discount_value
                                        );
                                    size.cost =
                                        size.cost - single_quantity_discount;
                                }

                                if (size.quantity > 0) {
                                    size.total_cost =
                                        this.icPriceFormat(size.cost, true) *
                                        parseInt(size.quantity);
                                    selected_color_obj.subtotal += parseFloat(
                                        size.total_cost
                                    );
                                    selected_color_obj.total_cost_gender_wise +=
                                        size.total_cost;
                                    selected_color_obj.total_qty_gender_wise +=
                                        parseInt(size.quantity);
                                }
                            }
                        });

                        selected_color_obj.imprint_locations =
                            this.imprint_locations;

                        selected_color_obj.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_design_fee
                        );

                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_discount_value += parseFloat(
                            selected_color_obj.total_discount_value
                        );
                        gender_element.total_design_fee += parseFloat(
                            selected_color_obj.total_design_fee
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                        gender_element.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_cost_gender_wise
                        );
                    }
                );
            }

            this.calcImprintLocationByGender();

            let total_colors = 0;
            let total_decoration_fee = 0;
            this.imprint_locations.forEach((location) => {
                if (location.is_selected) {
                    total_colors += parseInt(location.no_of_color || 0);
                    total_decoration_fee += parseFloat(
                        location.total_decoration_fee || 0
                    );
                }
            });

            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;
            if (this.product.PrintTemplate) {
                if (gender_element.total_qty_gender_wise > 0) {
                    this.per_color_setup_cost =
                        this.product.PrintTemplate.per_color_setup_cost;
                    this.setup_fee =
                        this.product.PrintTemplate.per_color_setup_cost *
                        total_colors;
                    if (this.setup_fee > 0) {
                        this.setup_fee_applied_gender_index = index;
                    }
                }
            }
            gender_element.total_color_fee = parseFloat(total_decoration_fee);
            gender_element.total_cost_gender_wise +=
                parseFloat(total_decoration_fee) + parseFloat(this.setup_fee);

            this.gender_groups[index] = gender_element;
        },

        calculateEmbroideryPricing(index) {
            let gender_element = this.gender_groups[index];

            gender_element.total_discount_value = 0;
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;
            gender_element.total_dark_category_fee = 0;
            gender_element.total_light_category_fee = 0;
            gender_element.total_decoration_discount_value = 0;
            gender_element.subtotal = 0;
            this.setup_fee = 0;

            if (gender_element["selected_colors"]) {
                let single_location_price = this.getDecorationPrice();
                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        selected_color_obj.total_discount_value = 0;
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.total_cost_gender_wise = 0;
                        selected_color_obj.total_design_fee = 0;
                        selected_color_obj.total_color_fee = 0;
                        selected_color_obj.total_dark_category_fee = 0;
                        selected_color_obj.total_light_category_fee = 0;
                        selected_color_obj.total_decoration_discount_value = 0;
                        selected_color_obj.setup_fee = 0;
                        selected_color_obj.subtotal = 0;
                        selected_color_obj["unique_sizes"].forEach((size) => {
                            if (
                                this.product.decoration_price_type ==
                                "global_price"
                            ) {
                                this.product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        this.product.price_base,
                                        this.product.decoration_type,
                                        this.product.decoration_price_template
                                    );
                                this.product.price_markup_value =
                                    (parseFloat(this.product.price_base) *
                                        parseFloat(
                                            this.product.price_markup_percentage
                                        )) /
                                    100;
                            }

                            let base_price = this.product.price_base;
                            let mark_up_cost = this.product.price_markup_value;
                            if (size.price_base > 0) {
                                base_price = size.price_base;
                                size.markup_percentage =
                                    this.product.price_markup_percentage;
                                if (
                                    this.product.decoration_price_type ==
                                    "global_price"
                                ) {
                                    size.markup_percentage =
                                        this.getMarkupFromTier(
                                            base_price,
                                            this.product.decoration_type,
                                            this.product
                                                .decoration_price_template
                                        );
                                }
                                mark_up_cost =
                                    (base_price * size.markup_percentage) / 100;
                            }

                            size.markup_price = mark_up_cost;

                            let color_category_price = 0;
                            if (selected_color_obj.category == "Dark") {
                                color_category_price =
                                    this.product.price_color_category_dark;
                                size.dark_price = color_category_price;
                                selected_color_obj.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_dark_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            } else if (selected_color_obj.category == "Light") {
                                color_category_price =
                                    this.product.price_color_category_light;
                                size.light_price = color_category_price;
                                selected_color_obj.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                                gender_element.total_light_category_fee +=
                                    parseFloat(color_category_price) *
                                    parseInt(size.quantity || 0);
                            }

                            size.ink_price = parseFloat(color_category_price);
                            size.single_location_price = parseFloat(
                                single_location_price
                            );
                            size.decoration_discount_percentage =
                                this.getDecorationDiscount();

                            if (
                                size.quantity != "undefined" &&
                                size.quantity > 0
                            ) {
                                // size.cost = parseFloat(base_price) + parseFloat(mark_up_cost) + parseFloat(color_category_price) + parseFloat(single_location_price);

                                size.cost = this.getRetailPrice({
                                    base_price: parseFloat(base_price),
                                    markup_price: parseFloat(mark_up_cost),
                                    single_location_price: parseFloat(
                                        single_location_price
                                    ),
                                    color_category_price:
                                        parseFloat(color_category_price),
                                    decoration_discount_percentage: parseFloat(
                                        size.decoration_discount_percentage
                                    ) // percentage%
                                });

                                // SALE DISCOUNT
                                if (this.product.NewProductDiscount !== null) {
                                    let discount_type =
                                        this.product.NewProductDiscount
                                            .discount_type;
                                    let discount_value = parseFloat(
                                        this.product.NewProductDiscount
                                            .discount_value
                                    );
                                    let single_quantity_discount = 0;
                                    if (discount_type == "Percent") {
                                        single_quantity_discount =
                                            (parseFloat(size.cost) *
                                                discount_value) /
                                            100;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    } else {
                                        single_quantity_discount =
                                            discount_value;
                                        size.discount =
                                            single_quantity_discount *
                                            parseInt(size.quantity);
                                    }
                                    selected_color_obj.total_discount_value +=
                                        parseFloat(size.discount);
                                    selected_color_obj.total_discount_value =
                                        parseFloat(
                                            selected_color_obj.total_discount_value
                                        );
                                    size.cost -= single_quantity_discount;
                                }

                                size.decoration_discount_value = 0;
                                if (size.quantity > 0) {
                                    if (size.decoration_discount_percentage) {
                                        size.decoration_discount_value =
                                            (this.icPriceFormat(
                                                size.cost,
                                                true
                                            ) *
                                                size.decoration_discount_percentage) /
                                            100;
                                    }
                                    size.total_cost =
                                        this.icPriceFormat(size.cost, true) *
                                        parseInt(size.quantity);
                                    selected_color_obj.subtotal += parseFloat(
                                        size.total_cost
                                    );
                                    selected_color_obj.total_cost_gender_wise +=
                                        size.total_cost;
                                    selected_color_obj.total_decoration_discount_value +=
                                        parseFloat(
                                            size.decoration_discount_value
                                        ) * parseInt(size.quantity);
                                    selected_color_obj.total_qty_gender_wise +=
                                        parseInt(size.quantity);
                                }
                            }
                        });

                        if (selected_color_obj.total_qty_gender_wise > 0) {
                            selected_color_obj.total_design_fee =
                                this.design_fee;
                        }

                        selected_color_obj.imprint_locations =
                            this.imprint_locations;

                        selected_color_obj.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_design_fee
                        );

                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_discount_value += parseFloat(
                            selected_color_obj.total_discount_value
                        );
                        gender_element.total_decoration_discount_value +=
                            parseFloat(
                                selected_color_obj.total_decoration_discount_value
                            );
                        gender_element.total_design_fee += parseFloat(
                            selected_color_obj.total_design_fee
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                        gender_element.total_color_fee += parseFloat(
                            selected_color_obj.total_color_fee
                        );
                        gender_element.total_cost_gender_wise += parseFloat(
                            selected_color_obj.total_cost_gender_wise
                        );
                    }
                );
            }

            this.calcImprintLocationByGender();

            let total_decoration_fee = 0;
            this.imprint_locations.forEach((location) => {
                if (location.is_selected) {
                    total_decoration_fee += parseFloat(
                        location.total_decoration_fee || 0
                    );
                }
            });

            this.setup_fee = 0;
            this.setup_fee_applied_gender_index = -1;
            if (this.product.Embroidery) {
                if (gender_element.total_qty_gender_wise > 0) {
                    this.setup_fee = this.product.Embroidery.machine_fee;
                    if (this.setup_fee > 0) {
                        this.setup_fee_applied_gender_index = index;
                    }
                }
            }
            gender_element.total_color_fee = parseFloat(total_decoration_fee);
            gender_element.total_cost_gender_wise +=
                parseFloat(total_decoration_fee) + parseFloat(this.setup_fee);

            this.gender_groups[index] = gender_element;
        },

        getDecorationPrice(
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );

            if (this.product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        qty_wise_color_price =
                            element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (this.product.decoration_type == 2) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        if (locationIndex > 0) {
                            qty_wise_color_price =
                                element[`location${locationIndex + 1}`];
                        } else {
                            qty_wise_color_price = element["cost"];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(additional = false) {
            let discount = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );

            if (this.product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            } else if (this.product.decoration_type == 2) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        onChangeGenderColor() {
            let _this = this;
            let thumb_array = [];
            let normal_array = [];
            let common_thumb_array = [];
            let common_normal_array = [];

            if (_this.product.NewProductImages) {
                _this.product.NewProductImages.forEach((element) => {
                    if (element.color_id) {
                        if (element.color_id == _this.selected_color.id) {
                            thumb_array.push({
                                id: element.id,
                                url: element.url,
                                thumb_url: element.thumbnail,
                                type: "image"
                            });
                            normal_array.push({
                                id: element.id,
                                url: element.url,
                                type: "image"
                            });
                        }
                    } else {
                        common_thumb_array.push({
                            id: element.id,
                            url: element.url,
                            thumb_url: element.thumbnail,
                            type: "image"
                        });
                        common_normal_array.push({
                            id: element.id,
                            url: element.url,
                            type: "image"
                        });
                    }
                });
            }

            if (thumb_array.length) {
                if (
                    _this.product.video_url &&
                    _this.product.video_url.trim() != ""
                ) {
                    thumb_array.push({
                        id: _this.product.id,
                        url: _this.product.video_url,
                        thumb_url: _this.product.video_url,
                        type: "video"
                    });
                    normal_array.push({
                        id: _this.product.id,
                        url: _this.product.video_url,
                        type: "video"
                    });
                }
                _this.images = {
                    thumbs: thumb_array,
                    normal_size: normal_array
                };
            } else {
                if (
                    _this.product.video_url &&
                    _this.product.video_url.trim() != ""
                ) {
                    common_thumb_array.push({
                        id: _this.product.id,
                        url: _this.product.video_url,
                        thumb_url: _this.product.video_url,
                        type: "video"
                    });
                    common_normal_array.push({
                        id: _this.product.id,
                        url: _this.product.video_url,
                        type: "video"
                    });
                }
                _this.images = {
                    thumbs: common_thumb_array,
                    normal_size: common_normal_array
                };
            }
        },

        getFavoriteProduct(product) {
            var _this = this;
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    _this.isBusy = true;
                    ApiService.get("/favorite-product/" + product.id)
                        .then(({ data }) => {
                            _this.favorite_product = data.favorite_product;
                            _this.is_favorite_product = data.favorite_product.id
                                ? true
                                : false;
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }
        },

        addToFavorite(product) {
            var _this = this;
            // setTimeout(() => {
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    // _this.isBusy = true;
                    let post_data = { product_id: product.id };
                    ApiService.post("/favorite-product", post_data)
                        .then(({ data }) => {
                            if (data.success) {
                                _this.$toast.success(data.message, {
                                    position: "top-right",
                                    queue: true
                                });
                            }
                            _this.is_favorite_product = true;
                            _this.getFavoriteProduct(_this.product);
                            // _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }
            // }, 1000);
        },

        getGendersGroups(gendersGroup) {
            return new Promise((resolve, reject) => {
                ApiService.post("/gender-age-sizes-byIds/", gendersGroup)
                    .then(({ data }) => {
                        if (data.success == true) {
                            data.genderagesize.forEach((elem) => {
                                let allsizes = [];
                                let usizes = [];
                                let sizes = JSON.parse(elem.sizes);
                                // sizes.forEach(element => {
                                this.product.NewSubProducts.forEach((elm) => {
                                    if (sizes.includes(elm.size_id)) {
                                        if (
                                            !allsizes.find(
                                                (s) => s.size_id == elm.size_id
                                            )
                                        ) {
                                            usizes.push(elm);
                                        }
                                        allsizes.push(elm);
                                    }
                                });
                                // });
                                if (allsizes.length > 0) {
                                    this.gender_groups.push({
                                        id: elem.id,
                                        prod_type_id: elem.prod_type_id,
                                        gender: elem.gender,
                                        total_cost_gender_wise: 0,
                                        total_qty_gender_wise: 0,
                                        total_cost: 0,
                                        sizes: allsizes,
                                        selected_colors: []
                                    });
                                }
                            });
                        } else {
                            this.$toast.error(data.error, {
                                position: "top-right"
                            });
                        }
                        resolve(data);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },

        loadVendorColors(product) {
            this.imprint_colors_array_for_template = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(
                        (decorator) =>
                            decorator.id == product.default_decorator_id
                    );
                    vendorColors = default_decorator.VendorColors;
                } else {
                    vendorColors = product.Decorators[0].VendorColors;
                }
                // Added Colors
                if (vendorColors.length > 0) {
                    for (const color of vendorColors) {
                        let colorExist =
                            this.imprint_colors_array_for_template.find(
                                (vendorColor) =>
                                    vendorColor.color_id == color.color_id
                            );
                        if (!color.Color || colorExist) {
                            continue;
                        }
                        let colorsData = {
                            color_id: color.color_id,
                            color_name: color.Color.name,
                            color_pms: color.Color.pms,
                            decor_upcharge: color.decor_upcharge,
                            color_value: color.Color.hex,
                            swatches: color.Color.swatches,
                            category: color.Color.category,
                            shades: color.Color.shades
                                ? JSON.parse(color.Color.shades)
                                : []
                        };

                        if (
                            color.Color.type == "ink" &&
                            this.decoration_type == 1
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "thread" &&
                            this.decoration_type == 2
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "vinyl" &&
                            this.decoration_type != 1 &&
                            this.decoration_type != 2
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        }
                    }
                    // Added new color Data in Product objects
                    if (product.Vendor) {
                        this.product.Vendor.newVendorColors =
                            this.imprint_colors_array_for_template;
                    }
                } else if (product.Vendor) {
                    let vendor_colors = product.Vendor.vendor_colors
                        ? JSON.parse(product.Vendor.vendor_colors)
                        : [];

                    if (this.decoration_type == 1) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_ink;
                    } else if (this.decoration_type == 2) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_thread;
                    } else {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_vinyl;
                    }
                }
            }
        },

        // Get Product Images
        getProductImages(color_id = null) {
            let _this = this;
            let thumb_array = [];
            let normal_array = [];
            return new Promise(() => {
                ApiService.get(
                    "/get-product-images/" + this.$route.params.id_of_product
                ).then(({ data }) => {
                    _this.product.NewProductImages = data.product_images;
                    if (_this.product.NewProductImages) {
                        _this.product.NewProductImages.forEach((element) => {
                            if (element.color_id == color_id) {
                                thumb_array.push({
                                    id: element.id,
                                    url: element.url,
                                    thumb_url: element.thumbnail,
                                    type: "image"
                                });
                                normal_array.push({
                                    id: element.id,
                                    url: element.url,
                                    type: "image"
                                });
                            }
                        });

                        _this.images = {
                            thumbs: thumb_array,
                            normal_size: normal_array
                        };
                    }
                });
            });
        },

        prepareDecorationPrices(decoration_type, price_decoration_bulk) {
            this.product.price_decoration_bulk = price_decoration_bulk;
            this.imprintcityColors = JSON.parse(
                JSON.stringify(this.default_imprint_colors)
            );
            if (decoration_type == 1) {
                let noOfColorsCount = price_decoration_bulk.no_of_colors;
                if (this.product.PrintTemplate.discount_enable) {
                    price_decoration_bulk.print_location1.forEach((row) => {
                        for (let i = 1; i < noOfColorsCount; i++) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }

                // Added Number of colors for Imprint Locations
                if (noOfColorsCount) {
                    this.imprintcityColors = [];
                    if (noOfColorsCount !== undefined && noOfColorsCount > 0) {
                        for (
                            let noOfColor = 1;
                            noOfColor <= noOfColorsCount;
                            noOfColor++
                        ) {
                            this.imprintcityColors.push({
                                id: parseInt(noOfColor),
                                value: noOfColor + "-colors"
                            });
                        }
                    }
                }

                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk.print_location1;
                this.decoration_price_template_values =
                    price_decoration_bulk.print_location1;
                this.decoration_price_template_location2 =
                    price_decoration_bulk.print_location2;
                this.minimum_quantity_decoration_fee =
                    this.decoration_price_template_values_for_imprint[0].colour1;
            } else if (decoration_type == 2) {
                let noOfColorsCount = this.product.Embroidery.no_of_colors;
                this.imprintcityColors = [];

                // Added Number of colors for Imprint Locations
                if (noOfColorsCount) {
                    if (noOfColorsCount !== undefined && noOfColorsCount > 0) {
                        for (
                            let noOfColor = 1;
                            noOfColor <= noOfColorsCount;
                            noOfColor++
                        ) {
                            this.imprintcityColors.push({
                                id: parseInt(noOfColor),
                                value: noOfColor + "-colors"
                            });
                        }
                    }
                }

                // price_decoration_bulk.forEach(decoration => {
                //     let decoration_cost = parseFloat(decoration.cost);
                //     let decoration_discount = decoration.discount ? parseFloat(decoration.discount) : 0;
                //     let decoration_discount_value = (decoration_cost * decoration_discount) / 100
                //     let decoration_final_cost = parseFloat(decoration.cost) - decoration_discount_value;
                //     decoration.cost = parseFloat(parseFloat(decoration_final_cost).toFixed(2));
                // })
                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk;
                this.decoration_price_template_values = price_decoration_bulk;

                this.minimum_quantity_decoration_fee =
                    this.decoration_price_template_values_for_imprint[0].cost;
            } else if (decoration_type == 3) {
                this.decoration_price_template_values_for_imprint =
                    price_decoration_bulk;
                this.decoration_price_template_values = price_decoration_bulk;
            }
        },

        getCompanionProduct(id) {
            let companion_values = {
                parent_id: id,
                t_shirt_24_hour: this.is_tshirt_24_hour
            };
            new Promise(() => {
                ApiService.post("/home-companion-new-product", companion_values)
                    .then(({ data }) => {
                        this.companion_products = data.product;
                        this.companion_products.forEach((product) => {
                            product["default_color_id"] = null;
                            if (product.NewSubProducts) {
                                if (this.is_tshirt_24_hour) {
                                    product.NewSubProducts =
                                        product.NewSubProducts.filter(
                                            (sub_product_data) =>
                                                sub_product_data.Color.name ==
                                                "White"
                                        );
                                }
                                let sub_product = product.NewSubProducts.find(
                                    (sub_product) =>
                                        sub_product.default_selection
                                );
                                if (sub_product) {
                                    product["default_color_id"] =
                                        sub_product.color_id;
                                }
                            }

                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },

        getMoreDecorations(more_decoration) {
            this.design_fee = 0;
            return new Promise((resolve, reject) => {
                if (more_decoration) {
                    let decoration_values = more_decoration
                        ? more_decoration
                        : [];
                    let more_decoration_values = {
                        decoration_ids: decoration_values
                    };
                    ApiService.post(
                        "/home-decoration-values",
                        more_decoration_values
                    )
                        .then(({ data }) => {
                            this.more_decoration_list = data.decoration;
                            this.more_decoration_list.forEach((decoration) => {
                                this.design_fee += parseFloat(decoration.price);
                            });
                            this.design_fee = parseFloat(
                                parseFloat(this.design_fee).toFixed(2)
                            );
                            resolve(data);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                }
                resolve();
            });
            // return false;
        },

        activeLink(index) {
            var _this = this;
            let currTab = _this.is_active;
            _this.is_active = index;
            /* eslint-disable */
            _this.images = jQuery.extend(true, {}, _this.temp_img);
            /* eslint-enable */
            this.onChangeGenderColor();
            if (currTab !== index) {
                _this.is_imprint_location = false;
            }

            if (this.gender_groups[this.is_active]) {
                const selected_color_ids = this.gender_groups[
                    this.is_active
                ].selected_colors.map((color) => color.id);
                this.colors.forEach((color) => {
                    color.is_selected = selected_color_ids.includes(color.id);
                });
            }
        },

        showMore(list) {
            var _this = this;
            _this[list] = _this[list] ? false : true;
        },

        getTiers() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/tiers")
                    .then(({ data }) => {
                        _this.tier_list = data.tiers;
                    })
                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },

        tireName(tier) {
            var unit_names = [];
            let tier_name = "";
            this.tier_list.forEach((element) => {
                if (tier == element.id) {
                    element.TierUnits.forEach((elm) => {
                        tier_name = element.name;
                        let unit_value =
                            `<div class="col pl-0 mx_2"> <p class="m-0">` +
                            elm.quantity +
                            `</p><p class="m-0">$` +
                            elm.price.toFixed(2) +
                            `</p></div>`;
                        unit_names.push(unit_value);
                    });
                }
            });

            let final_html =
                `<div class="dropdown">
<a href="#" class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">` +
                tier_name +
                `
</a>
<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
<h4 class="font_size_16 text_primary_blue py_2 px_20">Tier</h4>
<div class="scroll">
<div class="dropdown-item d-flex align-items-center">
` +
                unit_names.join(" ") +
                `
</div></div> </div></div>`;

            return final_html;
        },

        getCartItems() {
            new Promise((resolve, reject) => {
                ApiService.get("/cart")
                    .then(({ data }) => {
                        this.cart_items = data.cart_items;
                        this.updateCartQuantity();
                        if (data.max_cart_count) {
                            this.max_cart_count = parseInt(data.max_cart_count);
                        }
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        getUrlExtension(url) {
            if (!url) {
                return false;
            }
            let matchs = url.includes("data:application/pdf;base64");
            let postscript = url.includes("data:application/postscript;base64");
            if (postscript && this.images_name) {
                url = this.images_name.split(".")[1];
                return url;
            }
            if (matchs) {
                url = "pdf";
                return url;
                // return url.split(/[#?]/)[0].split('.').pop().trim();
            }
            return url.split(/[#?]/)[0].split(".").pop().trim();
        },

        isValidHttpUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },

        async changeDecorationService(index) {
            this.isBusy = true;
            this.setup_fee = false;
            this.decoration_services = JSON.parse(
                JSON.stringify(this.temp_decoration_services)
            );
            let decoration_service = this.decoration_services.find(
                (service, i) => i == index
            );
            if (decoration_service) {
                this.product.decoration_type = decoration_service.id;
                this.product.decoration_price_template =
                    decoration_service.decoration_price_template;
                this.product.price_decoration_bulk =
                    decoration_service.price_decoration_bulk;
                this.product.more_decoration =
                    decoration_service.more_decorations;
                this.product.price_color_category_dark =
                    decoration_service.price_dark || 0;
                this.product.price_color_category_light =
                    decoration_service.price_light || 0;

                if (this.product.decoration_price_type == "global_price") {
                    await this.$store
                        .dispatch(FETCH_DECORATION_PRICES, {
                            decoration_type: this.product.decoration_type,
                            decoration_price_template_id:
                                this.product.decoration_price_template
                        })
                        .then(() => {
                            this.product.price_decoration_bulk =
                                this.decorationPrices;
                        });

                    await this.$store
                        .dispatch(FETCH_DECORATION_TEMPLATE, {
                            decoration_type: this.product.decoration_type,
                            decoration_price_template_id:
                                this.product.decoration_price_template
                        })
                        .then(() => {
                            if (this.product.decoration_type === 1) {
                                this.product.PrintTemplate =
                                    this.decorationTemplate;
                                this.product.price_color_category_dark =
                                    this.decorationTemplate.price_dark;
                                this.product.price_color_category_light =
                                    this.decorationTemplate.price_light;
                            } else if (this.product.decoration_type === 2) {
                                this.product.Embroidery =
                                    this.decorationTemplate;
                                this.product.price_color_category_dark =
                                    this.decorationTemplate.price_dark;
                                this.product.price_color_category_light =
                                    this.decorationTemplate.price_light;
                            } else if (this.product.decoration_type === 3) {
                                this.product.price_color_category_dark =
                                    this.decorationTemplate.price_dark;
                                this.product.price_color_category_light =
                                    this.decorationTemplate.price_light;
                            }
                        });
                }

                this.decoration_type = this.product.decoration_type;
                this.is_imprint_location = false;
                this.prepareDecorationPrices(
                    this.product.decoration_type,
                    this.product.price_decoration_bulk
                );
                this.getMoreDecorations(
                    decoration_service.more_decorations
                ).then(() => {
                    this.calculatePricing(this.is_active);
                });
                this.loadVendorColors(this.product);
                decoration_service.isActive = true;
            }
            this.decoration_services.forEach(async (item, indx) => {
                item.isActive = indx == index;
            });
            this.isBusy = false;
        },

        getDecorationMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get("/decoration-methods")
                    .then(({ data }) => {
                        this.decoration_methods = data.decoration_methods;
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDecorationPriceFromTemplateIds() {
            let config_data = {
                print_template_ids: this.print_templates_id,
                embroidery_template_ids: this.embroidery_template_ids,
                promotional_template_ids: this.promotional_template_ids
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/get-decoration-pricing", config_data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        showBreakupCharges(gender) {
            if (
                this.setup_fee_applied_gender_index >= 0 &&
                this.setup_fee > 0
            ) {
                return true;
            } else if (gender.total_discount_value > 0) {
                return true;
            } else if (gender.total_design_fee > 0) {
                return true;
            } else if (gender.total_color_fee > 0) {
                return true;
            }

            return false;
        },

        shareOnFacebook() {
            const navUrl =
                "https://www.facebook.com/sharer/sharer.php?u=" +
                this.site_url +
                "product-details/" +
                this.product.id;
            window.open(navUrl, "_blank");
        },

        shareOnTwitter() {
            const navUrl =
                "https://twitter.com/intent/tweet?url=" +
                this.site_url +
                "product-details/" +
                this.product.id +
                "&text=Hello+Everyone+I+found+this+awesome+customisable+product+by+Imprint+City&hashtags=imprintCity,customizedPersonal,brand";
            window.open(navUrl, "_blank");
        },

        shareOnInstagram() {
            const navUrl =
                "https://www.instagram.com/sharer/sharer.php?u=" +
                this.site_url +
                "product-details/" +
                this.product.id +
                "&text=Hello+Everyone+I+found+this+awesome+customisable+product+by+Imprint+City&hashtags=imprintCity,customizedPersonal,brand";
            window.open(navUrl, "_blank");
        },

        updateCartQuantity(recalculate = false) {
            // this.current_cart_quantity = 0;
            // let selected_color_ids = [];
            // if (this.gender_groups[this.is_active]) {
            //     selected_color_ids = this.gender_groups[this.is_active].selected_colors.map(color => color.id);
            // }

            // this.same_artwork_cart_items = [];
            // if (this.product_artwork) {
            //     this.cart_items.forEach(item => {
            //         if (!item.build_id && (item.item_id == this.product.id)) {
            //             if (!selected_color_ids.includes(item.color_id) && (this.product_artwork == item.artwork)) {
            //                 this.current_cart_quantity += parseInt(item.total_quantity);
            //                 let cart_item = JSON.parse(JSON.stringify(item));
            //                 cart_item.imprint_locations = cart_item.imprint_locations
            //                     ? JSON.parse(cart_item.imprint_locations)
            //                     : []
            //                 this.same_artwork_cart_items.push(cart_item);
            //             } else if (selected_color_ids.includes(item.color_id) && (this.product_artwork == item.artwork)) {
            //                 this.gender_groups[this.is_active].selected_colors.forEach(selectedColor => {
            //                     if (selectedColor.id === item.color_id) {
            //                         selectedColor.existing_cart_quantity = parseInt(item.total_quantity);
            //                     }
            //                 })
            //             }
            //         }

            //     })
            // }

            if (recalculate) {
                this.calculatePricing(this.is_active);
            }
        },

        recalculateCartItems(cart_items) {
            let total_group_quantity = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );
            let single_location_price = this.calculateCostOfQtyForPrint(
                total_group_quantity + this.current_cart_quantity
            );

            cart_items.forEach((cart_item) => {
                cart_item.total_price =
                    parseFloat(cart_item.total_price) -
                    parseFloat(cart_item.subtotal_price) -
                    parseFloat(cart_item.imprint_locations_price);
                cart_item.imprint_locations_price = 0;
                cart_item.subtotal_price = 0;

                // UPDATING PRICES WITH NEW SINGLE LOCATION FOR EACH SIZE
                cart_item.CartChildItems.forEach((childItem) => {
                    childItem.unit_price =
                        parseFloat(childItem.unit_price) -
                        parseFloat(childItem.single_location_price);

                    childItem.total_price =
                        parseFloat(childItem.total_price) -
                        parseFloat(childItem.single_location_price) *
                            parseInt(childItem.quantity);

                    childItem.single_location_price = single_location_price;
                    childItem.unit_price =
                        parseFloat(childItem.unit_price) +
                        parseFloat(childItem.single_location_price);
                    childItem.total_price =
                        parseFloat(childItem.total_price) +
                        parseFloat(childItem.single_location_price) *
                            parseInt(childItem.quantity);

                    cart_item.subtotal_price =
                        parseFloat(cart_item.subtotal_price) +
                        parseFloat(childItem.total_price);
                });

                // UPDATING IMPRINT LOCATIONS PRICE WITH NEW SINGLE LOCATION
                if (cart_item.imprint_locations) {
                    let highest_price_location_index =
                        this.getHighestPriceLocation(
                            cart_item.imprint_locations
                        );
                    cart_item.imprint_locations.forEach(
                        (location, locationIndex) => {
                            location.colors.forEach(
                                (imprint_color, colorIndex) => {
                                    let qty_wise_color_price =
                                        this.getDecorationPrice(
                                            colorIndex,
                                            this.is_active,
                                            this.product.decoration_type
                                        );

                                    if (
                                        highest_price_location_index ==
                                        locationIndex
                                    ) {
                                        qty_wise_color_price =
                                            this.getDecorationPrice(
                                                colorIndex,
                                                this.is_active,
                                                this.product.decoration_type
                                            );
                                    } else {
                                        qty_wise_color_price =
                                            this.getDecorationPrice(
                                                colorIndex,
                                                this.is_active,
                                                this.product.decoration_type,
                                                true
                                            );
                                    }
                                    if (
                                        highest_price_location_index ==
                                            locationIndex &&
                                        colorIndex == 0
                                    ) {
                                        qty_wise_color_price = 0;
                                    }
                                    imprint_color.cost_cost =
                                        qty_wise_color_price *
                                        parseInt(cart_item.total_quantity);
                                    if (
                                        imprint_color.color &&
                                        imprint_color.color.decor_upcharge !==
                                            undefined &&
                                        imprint_color.color.decor_upcharge !==
                                            null
                                    ) {
                                        imprint_color.decor_upcharge.color_cost =
                                            parseFloat(
                                                imprint_color.color
                                                    .decor_upcharge || 0
                                            ) *
                                            parseInt(cart_item.total_quantity);
                                        cart_item.imprint_locations_price =
                                            parseFloat(
                                                imprint_color.cost_cost || 0
                                            ) +
                                            parseFloat(
                                                imprint_color.decor_upcharge
                                                    .color_cost || 0
                                            );
                                    } else if (
                                        imprint_color.color &&
                                        imprint_color.cost_cost
                                    ) {
                                        cart_item.imprint_locations_price =
                                            parseFloat(
                                                imprint_color.cost_cost || 0
                                            );
                                    }
                                }
                            );
                        }
                    );

                    cart_item.total_price =
                        parseFloat(cart_item.total_price) +
                        parseFloat(cart_item.imprint_locations_price);
                }

                cart_item.total_price =
                    parseFloat(cart_item.total_price) +
                    cart_item.subtotal_price;
            });
        },

        getDarkLightFees(color) {
            if (color) {
                if (color.category == "Dark") {
                    return parseFloat(this.product.price_color_category_dark);
                } else if (color.category == "Light") {
                    return parseFloat(this.product.price_color_category_light);
                }
            }

            return 0;
        },

        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },

        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) {
                return "";
            }
            return value.toString().toUpperCase();
        }
    },
    watch: {
        // isAuthenticatedClient: function (val) {
        //     if (val) {
        //         setTimeout(() => {
        //             this.UploadedImages();
        //         }, 100);
        //     }
        // }
    }
};
</script>
<style scoped>
button.add_artwork_preview_popup_btn {
    z-index: 1;
    position: relative;
}
</style>
